<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<span appLifecycleTracker trackerName="device-detail"></span>
<ng-container *ngIf="device">
    <div>
        <div class="heading-wrapper" [ngClass]="getBannerClasses()">
            <div class="title-wrapper">
                <div class="endpoint-name-wrapper">
                    <h1>
                        <button class="back-button" mat-mini-fab color="primary" routerLink="/endpoints" id="close-details"
                                aria-label="Go back to endpoints page." [ngStyle]="{transform: 'scale(0.7)'}">
                            <span class="mdi mdi-arrow-left left-icon"></span>
                        </button>{{device.computer_name}}
                    </h1>
                    <div>
                        <table role="presentation">
                            <tr>
                                <td>{{'PAGE_REFRESHED' | translate}}</td>
                                <td style="padding-left: 1em">
                                    <span *ngIf="!!lastRefresh; else refreshSkeleton">{{lastRefresh | date : 'short'}}</span>
                                    <ng-template #refreshSkeleton>
                                        <ngx-skeleton-loader count="1" [theme]="refreshTimeSkeletonTheme"></ngx-skeleton-loader>
                                    </ng-template>
                                </td>
                            </tr>
                            <tr>
                                <td>{{'ALC_CONFIG' | translate}}</td>
                                <td style="padding-left: 1em">{{device.last_config_dttm | date : 'short'}}</td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="status">
                    <ng-container *ngIf="isDisconnected(); else connected">
                        <h2><i class="mdi mdi-connection"></i> {{'D3ED_OFFLINE_LAST_KNOWN_STATE' | translate}}</h2>
                    </ng-container>
                    <ng-template #connected>
                        <h2 *ngIf="isLocked(); else standingGuard"><i class="mdi mdi-lock-alert-outline"></i> {{'END_LOCKED' | translate}}</h2>
                        <ng-template #standingGuard>
                            <h2><i class="mdi mdi-shield-lock"></i> {{'END_STANDING_GUARD' | translate}}</h2>
                        </ng-template>
                    </ng-template>
                    @if (!isAgentInstalled(device)) {
                        <div class="unlock-button-wrapper">
                            <button mat-raised-button [disabled]="!isLocked()"
                                    color="primary" (click)="clearThreats()" aria-label="Force policy reset for this device.">{{'END_UNLOCK_ENDPOINT' | translate}}</button>
                        </div>
                    }
                </div>
            </div>
            <div class="button-wrapper">
                <button id="add-licenses-button" mat-raised-button *ngIf="show_force_sync_btn" (click)="forceSyncConfig()"
                        class="renew-button" color="primary" [disabled]="device.force_sync === 1"
                        aria-label="Force this device to be re-synchronized.">{{'REFRESH_ENDPOINT' | translate}}</button>
                @if (!isAgentInstalled(device)) {
                    <button mat-raised-button id="force-policy" class="force-policy-reset"
                            [disabled]="!forcePolicyResetEnabled"
                            color="primary" (click)="forceResetPolicy()"
                            aria-label="Force policy reset for this device.">{{'FORCE_POLICY_RESET_BUTTON' | translate}}</button>
                }
            </div>
        </div>
    </div>
</ng-container>

<div *ngIf="!device" class="spinny">
    <mat-spinner></mat-spinner>
</div>

<mat-card appearance="raised" class="tab-wrapper"
          *ngrxLet="haveDataDefenseSubscription$ as haveDataDefenseSubscription">
    <mat-card-content *ngrxLet="haveBitlockerSubscription$ as haveBitlockerSubscription">
        <mat-tab-group *ngIf="device" [selectedIndex]="selectedTab">
            @if (isAgentInstalled(device) || haveDataDefenseSubscription) {
                <mat-tab>
                    <ng-template mat-tab-label>
                        <span class="tab-icon">
                          <span class="mdi mdi-access-point-network" aria-hidden="true"></span>
                        </span>
                        <span class="tab-title">{{fStatus}}</span>
                    </ng-template>
                    <div class="cards-container" *ngrxLet="getBannerClasses() as matCardClasses">
                        <div class="cards-wrapper">
                            <mat-card appearance="raised" [ngClass]="matCardClasses">
                                <mat-card-header id="last-seen-{{device.computer_name}}">
                                    <mat-card-title>{{'D3ED_LAST_SEEN' | translate}}</mat-card-title>
                                </mat-card-header>
                                <mat-card-content>
                                    <span *ngIf="isDisconnected(); else connected">{{device.last_check_dttm | date : 'short'}}</span>
                                    <ng-template #connected>
                                        <span>{{'JUST_NOW' | translate}}</span>
                                    </ng-template>
                                </mat-card-content>
                            </mat-card>
                            @if(haveDataDefenseSubscription) {
                                <mat-card appearance="raised" [ngClass]="matCardClasses">
                                    <mat-card-header>
                                        <mat-card-title>{{'D3ED_ACTIVETHREAT' | translate}}</mat-card-title>
                                    </mat-card-header>
                                    <mat-card-content>
                                        <span *ngIf="isDisconnected(); else isConnected">{{'UNKNOWN' | translate}}</span>
                                        <ng-template #isConnected>
                                            <div *ngIf="hasActiveLock(); else noActiveLock">
                                                <ng-container *ngFor="let threatId of activeLocks; let last = last">
                                                    <span>{{sensorsById[threatId]}}</span><span *ngIf="!last">, </span>
                                                </ng-container>
                                            </div>
                                            <ng-template #noActiveLock>
                                                <span>{{'NONE' | translate}}</span>
                                            </ng-template>
                                        </ng-template>
                                    </mat-card-content>
                                </mat-card>
                                <mat-card appearance="raised" [ngClass]="matCardClasses">
                                    <mat-card-header>
                                        <mat-card-title>{{'D3ED_MANLOCK' | translate}}</mat-card-title>
                                    </mat-card-header>
                                    <mat-card-content>
                                        <span *ngIf="isDisconnected(); else manualLockConnected">{{'UNKNOWN' | translate}}</span>
                                        <ng-template #manualLockConnected>
                                            <span *ngIf="hasManualLock(); else noManualLock">{{'ON' | translate}}</span>
                                            <ng-template #noManualLock>
                                                <span>{{'OFF' | translate}}</span>
                                            </ng-template>
                                        </ng-template>
                                    </mat-card-content>
                                </mat-card>
                            }
                        </div>
                        @if(this.configurationService.showAgentMenus) {
                            <mat-card class="bottom-card">

                                <mat-card-header>
                                    <mat-card-title class="bottom-title">
                                        {{'endpoints.agent-authorization-title' | translate}}
                                    </mat-card-title>
                                </mat-card-header>

                                <mat-card-content>
                                    <div class="base-indent">
                                        <div class="info-grid">

                                            <div class="label">{{'endpoints.pba-section-title' | translate}}</div>
                                            <div class="label">{{ getPbaAuthorization() }}</div>
                                            <div class="value">{{'endpoints.last-verified' | translate}} {{device.last_config_dttm | date : 'short'}}</div>

                                            <div class="label">{{'endpoints.fde-section-title' | translate}}</div>
                                            <div class="label">{{ getFdeAuthorization() }}</div>
                                            <div class="value">{{'endpoints.last-verified' | translate}} {{device.last_config_dttm | date : 'short'}}</div>
                                            <!-- @if(haveDataDefenseSubscription) {
                                                <div class="label">{{'endpoints.data-defense-section-title' | translate}}</div>
                                                <div class="label">{{ getAuthorization() }}</div>
                                                <div class="value">{{'endpoints.last-verified' | translate}} Time</div>
                                            } -->
                                        </div>
                                    </div>
                                </mat-card-content>

                            </mat-card>
                        }
                    </div>

    <!--
                            <ul *ngIf="hasActiveLock()" class="active-lock-list">
                                <li class="header">
                                    <span class="threat-header">{{fActiveThreat}}</span>
                                    <span>{{fActivated}}</span>
                                </li>
                                <ng-container *ngFor="let threatId of device.state.activeLock;">
                                    <li>
                                        <span class="lock-list-item-threat">{{sensorsById[threatId]}}</span>
                                        <span class="activated-col">
                                            <span class="threat-date">
                                                {{hasActiveLockDate(threatId) ? fActivated+' - ' + (getActiveLockDate(threatId) | date: 'medium') : fCaseD}}
                                            </span>
                                        </span>
                                    </li>
                                </ng-container>
                            </ul>

                            <h2>{{fFeatureStatus}}</h2>
                            <ul class="feature-status-list">
                                <li>
                                    <span class="feature-list-item-title" id="secure-drive-status">{{fSecureDrives}}</span>
                                    <span>{{device.opal_enabled ? fConfigured : fUnconfigured}}</span>
                                </li>
                                <li>
                                    <span class="feature-list-item-title" id="file-type-protection-status">{{fFileProt}}</span>
                                    <span>{{device.ext_enabled ? fEnabled : fDisabled}}</span>
                                </li>
                                <li>
                                    <span class="feature-list-item-title" id="folder-protection-status">{{fFolderProt}}</span>
                                    <span>{{device.folder_enabled ? fEnabled : fDisabled}}</span>
                                </li>
                                <li>
                                    <span class="feature-list-item-title" id="deception-files-status">{{fDecepFiles}}</span>
                                    <span>{{device.deception_enabled ? fConfigured : fUnconfigured}}</span>
                                </li>
                                <li>
                                    <span class="feature-list-item-title" id="network-deception-status">{{fNetDeception}}</span>
                                    <span>{{isNetworkDeceptionEnabled ? fEnabled : fDisabled}}</span>
                                </li>
                            </ul>-->
                </mat-tab>
            }
            <mat-tab>
                <ng-template mat-tab-label>
                    <span class="tab-icon">
                      <span class="mdi mdi-monitor-star" aria-hidden="true"></span>
                    </span>
                    <span class="tab-title">{{'DETAILS' | translate}}</span>
                </ng-template>
                @if (this.configurationService.showAgentMenus && (isAgentInstalled(device))) {
                    <div class="cards-container" *ngrxLet="getBannerClasses() as matCardClasses">
                        <div class="details-cards-wrapper">
                            <mat-card appearance="raised" [ngClass]="matCardClasses">
                                <mat-card-header id="last-seen-{{device.computer_name}}">
                                    <mat-card-title>{{'endpoints.partitions.volume_encryption_type_enum.hardware' | translate}}</mat-card-title>
                                </mat-card-header>
                                <mat-card-content>
                                    <div class="general-system-wrapper">
                                        <div class="general-system-data">
                                            <div>
                                                <ul>
                                                    <li>
                                                        <span class="title" id="dv-cmp">{{'endpoints.endpoint-id' | translate}}</span>
                                                        <span>{{device.bios_serial}}</span>
                                                    </li>
                                                    <li *ngIf="showFeatures">
                                                        <span class="title" id="dv-feature-mask">Feature Mask</span>
                                                        <span class="hex-number">{{device.feature_flags_sent?.toString(16)}}</span>
                                                    </li>
                                                    <li>
                                                        <span class="title" id="dv-man">{{fManufacturer}}</span>
                                                        <span>{{device.manufacturer}}</span>
                                                    </li>
                                                    <li>
                                                        <span class="title" id="dv-mod">{{fModel}}</span>
                                                        <span>{{device.model}}</span>
                                                    </li>
                                                    <li>
                                                        <span class="title" id="dv-sys">{{fSysSerial}}</span>
                                                        <span>{{device.system_serial}}</span>
                                                    </li>
                                                    <li>
                                                        <span class="title" id="dv-os">{{fOSSerial}}</span>
                                                        <span>{{device.os_serial || fNotAvail }}</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </mat-card-content>
                            </mat-card>
                            <mat-card appearance="raised" [ngClass]="matCardClasses">
                                <mat-card-header>
                                    <mat-card-title>{{'installed_cigent_products' | translate}}</mat-card-title>
                                </mat-card-header>
                                    <mat-card-content>
                                        <table class="device-summary-table">

                                            <!-- Header row -->
                                            <div class="table-header">{{'L_PRODUCT' | translate}}</div>
                                            <div class="table-header">{{'VERSION' | translate}}</div>
                                            <div class="table-header">{{'SSSD_STATE' | translate}}</div>

                                            <!-- Row 1 -->
                                            <div class="table-cell">{{'endpoints.pba-section-title' | translate}}</div>
                                            @if (getPbaInfo(device)?.version?.trim()) {
                                                <div class="table-cell">{{ getPbaInfo(device)?.version?.trim() }}</div>
                                                <div class="table-cell">
                                                    {{
                                                        getPbaInfo(device)?.enabled
                                                            ? ('ACTIVE' | translate)
                                                            : ('INACTIVE' | translate)
                                                    }}
                                                </div>
                                            } @else {
                                                <div class="table-cell">(not installed)</div>
                                                <div class="table-cell"></div>
                                            }

                                            <!-- Row 2 -->
                                            <div class="table-cell">{{'endpoints.fde-section-title' | translate}}</div>
                                            @if (getFdeVolume(device)?.volume_encryption?.version?.trim()) {
                                                <div class="table-cell">{{ getFdeVolume(device)?.volume_encryption?.version?.trim() }}</div>
                                                <div class="table-cell">
                                                    {{
                                                        getFdeVolume(device)?.volume_encryption?.enabled
                                                            ? ('ACTIVE' | translate)
                                                            : ('INACTIVE' | translate)
                                                    }}
                                                </div>
                                            } @else {
                                                <div class="table-cell">(not installed)</div>
                                                <div class="table-cell"></div>
                                            }

                                            <!-- Row 3 -->
                                            <div class="table-cell">{{'endpoints.cli-agent-section-title' | translate}}</div>
                                            <div class="table-cell">{{ isAgentInstalled(device) ? device.agent_version : '(not installed)' }}</div>
                                            <div class="table-cell">{{ isAgentInstalled(device) ? ('ACTIVE' | translate) : '' }}</div>

                                            <!-- Row 4 -->
                                            <!-- <div class="table-cell">{{'endpoints.cli-agent-section-title' | translate}}</div>
                                            <div class="table-cell">{{ isAgentInstalled(device) ? device.agent_version : '(not installed)' }}</div>
                                            <div class="table-cell">{{ isAgentInstalled(device) ? ('ACTIVE' | translate) : '' }}</div> -->
                                        </table>
                                    </mat-card-content>
                            </mat-card>
                        </div>
                        <mat-card class="bottom-card">

                            <mat-card-header>
                                <mat-card-title class="bottom-title">
                                    {{ 'TITLE_LICENSING' | translate}}
                                </mat-card-title>
                            </mat-card-header>

                            <mat-card-content>

                                <div class="details-table">

                                    <!-- Header row -->
                                    <div class="table-header">{{ 'L_PRODUCT' | translate}}</div>
                                    <div class="table-header">{{ 'endpoints.license-state' | translate}}</div>
                                    <div class="table-header">{{ 'endpoints.license-expires' | translate}}</div>
                                    <div class="table-header">{{ 'endpoints.maintenance-state' | translate}}</div>
                                    <div class="table-header">{{ 'MAINT_EXPIRES' | translate}}</div>
                                    <div class="table-header">{{ 'endpoints.assigned' | translate}}</div>

                                    <!-- Row 1 -->
                                    <div class="table-cell">{{'endpoints.pba-section-title' | translate}}</div>
                                    @if (getPbaInfo(device)) {
                                        @if (getPbaLicenseInfo(device, getPbaSerial(device)); as license) {
                                            <div class="table-cell">{{'assign.columns.licensed' | translate}}</div>
                                            <div class="table-cell">{{ getPbaLicExpirationDisplay(license) }}</div>
                                            <div class="table-cell">{{ getPbaLicenseStatus(license) }}</div>
                                            <div class="table-cell">{{ getPbaMaintExpirationDisplay(license) }}</div>
                                            <div class="table-cell">{{ license.created_dttm | date:'short' }}</div>
                                        } @else {
                                            <div class="table-cell">N/A</div>
                                            <div class="table-cell">-</div>
                                            <div class="table-cell">-</div>
                                            <div class="table-cell">-</div>
                                            <div class="table-cell">-</div>
                                        }
                                    } @else {
                                        <div class="table-cell">N/A</div>
                                        <div class="table-cell">-</div>
                                        <div class="table-cell">-</div>
                                        <div class="table-cell">-</div>
                                        <div class="table-cell">-</div>
                                    }

                                    <!-- Row 2 -->
                                    <div class="table-cell">{{'endpoints.fde-section-title' | translate}}</div>
                                    @if (device.db_fde_license_info) {
                                        <div class="table-cell">{{'assign.columns.licensed' | translate}}</div>
                                        <div class="table-cell">{{ getFdeLicExpirationDisplay(device.db_fde_license_info) }}</div>
                                        <div class="table-cell">{{ getFdeLicenseStatus(device.db_fde_license_info) }}</div>
                                        <div class="table-cell">{{ getFdeMaintExpirationDisplay(device.db_fde_license_info) }}</div>
                                        <div class="table-cell">{{ device.db_fde_license_info.created_dttm | date:'short' }}</div>
                                    } @else {
                                        <div class="table-cell">N/A</div>
                                        <div class="table-cell">-</div>
                                        <div class="table-cell">-</div>
                                        <div class="table-cell">-</div>
                                        <div class="table-cell">-</div>
                                    }

                                    <!-- Row 3 -->
                                    <!-- @if(haveDataDefenseSubscription) {
                                        <div class="table-cell">{{'endpoints.data-defense-section-title' | translate}}</div>
                                        <div class="table-cell">Unprotected</div>
                                        <div class="table-cell">None</div>
                                        <div class="table-cell">N/A</div>
                                        <div class="table-cell">1.2</div>
                                        <div class="table-cell">Unavailable</div>
                                    } -->

                                </div>

                                <div class="bottom-text">
                                </div>

                            </mat-card-content>

                        </mat-card>
                    </div>
                }
                @if (!this.configurationService.showAgentMenus || (!isAgentInstalled(device))) {
                    <mat-card appearance="raised">
                        <mat-card-header>
                            <mat-card-title><span class="mdi mdi-information-outline title-icon"></span>{{fGeneral}}</mat-card-title>
                        </mat-card-header>
                        <mat-card-content>
                            <div class="general-system-wrapper">
                                <div class="general-system-data">
                                    <div>
                                        <ul>
                                            <li>
                                                <span class="title" id="dv-cmp">{{fHost}}</span>
                                                <span>{{device.computer_name}}</span>
                                            </li>
                                            <li *ngIf="device.version">
                                                <span class="title" id="dv-ver">{{fVersion}}</span>
                                                <span>{{device.version}}</span>
                                            </li>
                                            <li>
                                                <span class="title" id="dv-con">{{fLastContact}}</span>
                                                <span>{{ (device.last_check_dttm || fNever) | date : 'long' }}</span>
                                            </li>
                                            <li>
                                                <span class="title" id="dv-org">{{'ORG_ORG' | translate}}</span>
                                                <span>{{device.organizationName}}</span>
                                            </li>
                                            <li>
                                                <span class="title" id="dv-primary-email">{{'EMAIL' | translate}}</span>
                                                <span>{{device.PrimaryEmail}}</span>
                                            </li>
                                            <li *ngIf="showFeatures">
                                                <span class="title" id="dv-feature-mask">Feature Mask</span>
                                                <span class="hex-number">{{device.feature_flags_sent.toString(16)}}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="general-system-data">
                                    <div>
                                        <ul>
                                            <li>
                                                <span class="title" id="dv-sub-id">{{'ORG_SUB' | translate}}</span>
                                                <span>{{device.subscriptionName}}</span>
                                            </li>
                                            <li>
                                                <span class="title" id="dv-man">{{fManufacturer}}</span>
                                                <span>{{device.manufacturer}}</span>
                                            </li>
                                            <li>
                                                <span class="title" id="dv-mod">{{fModel}}</span>
                                                <span>{{device.model}}</span>
                                            </li>
                                            <li>
                                                <span class="title" id="dv-sys">{{fSysSerial}}</span>
                                                <span>{{device.system_serial}}</span>
                                            </li>
                                            <li>
                                                <span class="title" id="dv-os">{{fOSSerial}}</span>
                                                <span>{{device.os_serial || fNotAvail }}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                }
                @if (!this.configurationService.showAgentMenus || (!isAgentInstalled(device) || showFeatures)) {
                    <ng-container *ngIf="device.config">
                        <mat-card appearance="raised">
                            <mat-card-header>
                            <mat-card-title><span class="mdi mdi-harddisk title-icon"></span>{{fDisks}}</mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                            <div>
                                <mat-table [dataSource]="device.config.disks">
                                    <ng-container matColumnDef="model">
                                        <th scope="col" mat-header-cell *matHeaderCellDef><span class="table-th-header">{{fModel}}</span></th>
                                        <td mat-cell *matCellDef="let disk"> {{ getDrive(disk).model }} </td>
                                    </ng-container>

                                    <ng-container matColumnDef="serial">
                                        <th scope="col" mat-header-cell *matHeaderCellDef>{{'endpoints.partitions.disk_serial' | translate}}</th>
                                        <td mat-cell *matCellDef="let disk"> {{ getDrive(disk).serial }} </td>
                                    </ng-container>

                                    <ng-container matColumnDef="size">
                                        <th scope="col" mat-header-cell *matHeaderCellDef>{{fSize}}</th>
                                        <td mat-cell *matCellDef="let disk"> {{ getDrive(disk) | diskSize }} </td>
                                    </ng-container>

                                    <ng-container matColumnDef="type">
                                        <th scope="col" mat-header-cell *matHeaderCellDef>{{fType}}</th>
                                        <td mat-cell *matCellDef="let disk"> {{ disk.type }} </td>
                                    </ng-container>

                                    <ng-container matColumnDef="secure">
                                        <th scope="col" mat-header-cell *matHeaderCellDef> {{fSecureDrives}}</th>
                                        <td mat-cell *matCellDef="let disk"> {{ getOpalState(disk) }} </td>
                                    </ng-container>

                                    <ng-container matColumnDef="volumes">
                                        <th scope="col" mat-header-cell *matHeaderCellDef>{{fVolumes}}</th>
                                        <td mat-cell class="center-text"
                                            *matCellDef="let disk"> {{ (disk.volumes && disk.volumes.length) || 0 }} </td>
                                    </ng-container>

                                    <ng-container matColumnDef="firmware">
                                        <th scope="col" mat-header-cell *matHeaderCellDef>{{fFirmware}}</th>
                                        <td mat-cell *matCellDef="let disk"> {{ disk.fw }} </td>
                                    </ng-container>

                                    <ng-container matColumnDef="opal_state">
                                        <th scope="col" mat-header-cell *matHeaderCellDef>{{'OPAL_STATE' | translate}}</th>
                                        <td mat-cell *matCellDef="let disk"> {{ getOpalStateText(disk) }}</td>
                                    </ng-container>

                                    <ng-container matColumnDef="pba_installed">
                                        <th scope="col" mat-header-cell *matHeaderCellDef>PBA</th>
                                        <td mat-cell *matCellDef="let disk">{{getPBAInfo(disk)}}</td>
                                    </ng-container>

                                    <ng-container matColumnDef="tcg_support">
                                        <th scope="col" mat-header-cell *matHeaderCellDef>{{'TCG_SUPPORT' | translate}}</th>
                                        <td mat-cell *matCellDef="let disk"> {{ getTcgSupport(disk) }}</td>
                                    </ng-container>

                                    <ng-container matColumnDef="keepalive_enabled">
                                        <th scope="col" mat-header-cell *matHeaderCellDef>{{fKeepAlive}}</th>
                                        <td mat-cell *matCellDef="let disk">
                                    <span *ngIf="isBitSet(disk, SUPPORT_KEEPALIVE); else keepaliveNotSupported">
                                    {{isBitSet(disk, ENABLED_KEEPALIVE) ? fEnabled : fDisabled}}
                                    </span>
                                            <ng-template #keepaliveNotSupported>
                                                <span> {{'N_A' | translate}} </span>
                                            </ng-template>
                                        </td>
                                    </ng-container>

                                    <ng-container matColumnDef="cmd_logging_enabled">
                                        <th scope="col" mat-header-cell *matHeaderCellDef>{{fCommandLogging}}</th>
                                        <td mat-cell
                                            *matCellDef="let disk">
                                    <span *ngIf="isBitSet(disk, SUPPORT_CMD_LOGGING); else commandLoggingNotSupported">
                                    {{isBitSet(disk, ENABLED_CMD_LOGGING) ? fEnabled : fDisabled}}
                                    </span>
                                            <ng-template #commandLoggingNotSupported>
                                                <span> {{'N_A' | translate}} </span>
                                            </ng-template>
                                        </td>
                                    </ng-container>

                                    <ng-container *ngIf="showRansomware" matColumnDef="ransomware_detection">
                                        <th scope="col" mat-header-cell *matHeaderCellDef>{{'ssd.details.ransomware' | translate}}</th>
                                        <td  mat-cell *matCellDef="let disk">
                                        <span *ngIf="isBitSet(disk, SUPPORTS_SMCU); else ransomwareNotSupported">
                                        {{ isBitSet(disk, ACTIVE_RANSOMWARE) ? fEnabled : fDisabled}}
                                        </span>
                                            <ng-template #ransomwareNotSupported>
                                                <span> {{'N_A' | translate}} </span>
                                            </ng-template>
                                        </td>
                                    </ng-container>

                                    <ng-container *ngIf="showRansomware" matColumnDef="ransomware_sensitivity">
                                        <th scope="col" mat-header-cell *matHeaderCellDef>{{'ssd.details.ransomware-sensitivity' | translate}}</th>
                                        <td  mat-cell *matCellDef="let disk">
                                        <span *ngIf="isBitSet(disk, SUPPORTS_SMCU); else ransomwareNotSupported">
                                        {{ isBitSet(disk, ACTIVE_RANSOMWARE) ? getSensitivity(disk) : fDisabled}}
                                        </span>
                                            <ng-template #ransomwareNotSupported>
                                                <span> {{'N_A' | translate}} </span>
                                            </ng-template>
                                        </td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="diskColumns"></tr>
                                    <tr mat-row *matRowDef="let myRowData; columns: diskColumns"></tr>
                                </mat-table>
                            </div>
                            </mat-card-content>
                        </mat-card>
                        <mat-card appearance="raised">
                            <mat-card-header>
                                <mat-card-title><span class="mdi mdi-inbox-multiple-outline title-icon"></span>{{'endpoints.partitions.table_title' | translate}}</mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="partitions-header">
                                    <div class="seperator"></div>
                                    <div class="partitions-control">
                                        <mat-checkbox id="showmounted" [checked]="showOnlyMounted" (change)="changeShowOnlyMounted()">
                                            <mat-label >{{'endpoints.partitions.showonlymounted' | translate}}</mat-label>
                                        </mat-checkbox>
                                    </div>
                                    <div class="column-chooser">
                                        <app-column-chooser saveId="endpointPartitions" [elements]="this.partitionColumns" (change)="updateDisplayedColumns($event)"></app-column-chooser>
                                    </div>
                                </div>
                                <div>
                                    <mat-table [dataSource]="volumes">
                                        <ng-container matColumnDef="guid">
                                            <th scope="col" mat-header-cell *matHeaderCellDef><span class="table-th-header">{{'endpoints.partitions.guid' | translate}}</span></th>
                                            <td mat-cell *matCellDef="let volume"> {{ volume.guid }} </td>
                                        </ng-container>

                                        <ng-container matColumnDef="label">
                                            <th scope="col" mat-header-cell *matHeaderCellDef><span class="table-th-header">{{'endpoints.partitions.label' | translate}}</span></th>
                                            <td mat-cell *matCellDef="let volume"> {{ volume.label }} </td>
                                        </ng-container>

                                        <ng-container matColumnDef="mount">
                                            <th scope="col" mat-header-cell *matHeaderCellDef>{{'endpoints.partitions.mount' | translate}}</th>
                                            <td mat-cell *matCellDef="let volume"> {{ volume.mount }} </td>
                                        </ng-container>

                                        <ng-container matColumnDef="disk_serial">
                                            <th scope="col" mat-header-cell *matHeaderCellDef>{{'endpoints.partitions.disk_serial' | translate}}</th>
                                            <td mat-cell *matCellDef="let volume"> {{ volume.diskSerial }} </td>
                                        </ng-container>

                                        <ng-container matColumnDef="volume_type">
                                            <th scope="col" mat-header-cell *matHeaderCellDef>{{'endpoints.partitions.volume_type' | translate}}</th>
                                            <td mat-cell *matCellDef="let volume"> {{ getVolumeTypeDisplay(volume) }} </td>
                                        </ng-container>

                                        <ng-container matColumnDef="filesystem">
                                            <th scope="col" mat-header-cell *matHeaderCellDef>{{'endpoints.partitions.filesystem' | translate}}</th>
                                            <td mat-cell *matCellDef="let volume"> {{ volume.filesystem }} </td>
                                        </ng-container>

                                        <ng-container matColumnDef="size">
                                            <th scope="col" mat-header-cell *matHeaderCellDef>{{'endpoints.partitions.size' | translate}}</th>
                                            <td mat-cell *matCellDef="let volume"> {{ volume | diskSize }} </td>
                                        </ng-container>

                                        <ng-container matColumnDef="locked">
                                            <th scope="col" mat-header-cell *matHeaderCellDef>{{'endpoints.partitions.locked' | translate}}</th>
                                            <td mat-cell *matCellDef="let volume"> {{ getLockedDisplay(volume) }} </td>
                                        </ng-container>


                                        <ng-container matColumnDef="protection">
                                            <th scope="col" mat-header-cell *matHeaderCellDef>{{ 'endpoints.partitions.protection' | translate}}</th>
                                            <td mat-cell *matCellDef="let volume"> {{ getVolumeProtectionDisplay(volume) }} </td>
                                        </ng-container>


                                        <ng-container matColumnDef="encryption">
                                            <th scope="col" mat-header-cell *matHeaderCellDef>{{'endpoints.partitions.encryption' | translate}}</th>
                                            <td mat-cell *matCellDef="let volume">
                                                <span *ngIf="volume.volume_encryption != undefined">{{ volume.volume_encryption.encryption }}</span>
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="protectors">
                                            <th scope="col" mat-header-cell *matHeaderCellDef>{{'endpoints.partitions.protectors' | translate}}</th>
                                            <td mat-cell *matCellDef="let volume">
                                                <span *ngIf="volume.volume_encryption != undefined">{{ volume.volume_encryption.protector_display }}</span>
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="encryption_type">
                                            <th scope="col" mat-header-cell *matHeaderCellDef>{{'endpoints.partitions.encryption_type' | translate}}</th>
                                            <td mat-cell *matCellDef="let volume">
                                                <span *ngIf="volume.volume_encryption != undefined">{{ getVolumeEncryption(volume) }}</span>
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="encryption_flags">
                                            <th scope="col" mat-header-cell *matHeaderCellDef>{{'endpoints.partitions.encryption_flags' | translate}}</th>
                                            <td mat-cell *matCellDef="let volume">
                                                <span *ngIf="volume.volume_encryption != undefined">{{ getVolumeFlagsDisplay(volume) }}</span>
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="status">
                                            <th scope="col" mat-header-cell *matHeaderCellDef>{{'endpoints.partitions.status' | translate}}</th>
                                            <td mat-cell *matCellDef="let volume">
                                                <span *ngIf="volume.volume_encryption != undefined">{{ getVolumeStatusDisplay(volume) }}</span>
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="percent_encrypted">
                                            <th scope="col" mat-header-cell *matHeaderCellDef>{{'endpoints.partitions.percent_encrypted' | translate}}</th>
                                            <td mat-cell *matCellDef="let volume">
                                                <span *ngIf="volume.volume_encryption != undefined">{{ volume.volume_encryption.percent_encrypted }}</span>
                                            </td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef="partitionColumnsToDisplay"></tr>
                                        <tr mat-row *matRowDef="let myRowData; columns: partitionColumnsToDisplay"></tr>
                                    </mat-table>
                                </div>
                            </mat-card-content>
                        </mat-card>
<!--                    <ng-container *ngIf="device.config && isAgentInstalled(device)">-->
<!--                        <mat-card appearance="raised">-->
<!--                        <mat-card-header>-->
<!--                            <mat-card-title><span class="mdi mdi-shield-lock-outline title-icon"></span>{{'pba-settings.title' | translate}}</mat-card-title>-->
<!--                        </mat-card-header>-->
<!--                        <mat-card-content>-->
<!--                            @for (disk of device.config?.disks; track $index;) {-->
<!--                                @if (disk?.pba_info?.settings) {-->
<!--                                    <hr />-->
<!--                                    <div class="pba-wrapper">-->
<!--                                    <div class="pba-column">-->
<!--                                        <ul>-->
<!--                                        <li>-->
<!--                                            <span class="pba-label">{{'pba-settings.disk-model' | translate}}</span>-->
<!--                                            <span>{{ getDrive(disk).model }}</span>-->
<!--                                        </li>-->
<!--                                        <li>-->
<!--                                            <span class="pba-label">{{'pba-settings.serial' | translate}}</span>-->
<!--                                            <span>{{disk?.serial}}</span>-->
<!--                                        </li>-->
<!--                                        <li>-->
<!--                                            <span class="pba-label">-->
<!--                                            {{'pba-settings.failed-logins-before-lockout' | translate}}-->
<!--                                            <span tabindex="0"-->
<!--                                                attr.aria-label="{{'pba-settings.failed-logins-before-lockout-tooltip' | translate}}"-->
<!--                                                matTooltip="{{'pba-settings.failed-logins-before-lockout-tooltip' | translate}}"-->
<!--                                                matTooltipPosition="right">-->
<!--                                                <span class="mdi mdi-information-outline"></span>-->
<!--                                            </span>-->
<!--                                            </span>-->
<!--                                            <span>{{disk?.pba_info?.settings?.failed_logins_before_lockout}}</span>-->
<!--                                        </li>-->
<!--                                        <li>-->
<!--                                            <span class="pba-label">-->
<!--                                            {{'pba-settings.failed-logins-before-erase' | translate}}-->
<!--                                            <span tabindex="0"-->
<!--                                                attr.aria-label="{{'pba-settings.failed-logins-before-erase-tooltip' | translate}}"-->
<!--                                                matTooltip="{{'pba-settings.failed-logins-before-erase-tooltip' | translate}}"-->
<!--                                                matTooltipPosition="right">-->
<!--                                                <span class="mdi mdi-information-outline"></span>-->
<!--                                            </span>-->
<!--                                            </span>-->
<!--                                            <span>{{disk?.pba_info?.settings?.failed_logins_before_erase}}</span>-->
<!--                                        </li>-->
<!--                                        <li>-->
<!--                                            <span class="pba-label">-->
<!--                                            {{'pba-settings.password-history' | translate}}-->
<!--                                            <span tabindex="0"-->
<!--                                                attr.aria-label="{{'pba-settings.password-history-tooltip' | translate}}"-->
<!--                                                matTooltip="{{'pba-settings.password-history-tooltip' | translate}}"-->
<!--                                                matTooltipPosition="right">-->
<!--                                                <span class="mdi mdi-information-outline"></span>-->
<!--                                            </span>-->
<!--                                            </span>-->
<!--                                            <span>{{disk?.pba_info?.settings?.password_history}}</span>-->
<!--                                        </li>-->
<!--                                        </ul>-->
<!--                                    </div>-->
<!--                                    <div class="pba-column">-->
<!--                                        <ul>-->
<!--                                        <li>-->
<!--                                            <span class="pba-label">-->
<!--                                            {{'pba-settings.password-min-length' | translate}}-->
<!--                                            <span tabindex="0"-->
<!--                                                attr.aria-label="{{'pba-settings.password-min-length-tooltip' | translate}}"-->
<!--                                                matTooltip="{{'pba-settings.password-min-length-tooltip' | translate}}"-->
<!--                                                matTooltipPosition="right">-->
<!--                                                <span class="mdi mdi-information-outline"></span>-->
<!--                                            </span>-->
<!--                                            </span>-->
<!--                                            <span>{{disk?.pba_info?.settings?.password_min}}</span>-->
<!--                                        </li>-->
<!--                                        <li>-->
<!--                                            <span class="pba-label">-->
<!--                                            {{'pba-settings.mfa' | translate}}-->
<!--                                            <span tabindex="0"-->
<!--                                                attr.aria-label="{{'pba-settings.mfa-tooltip' | translate}}"-->
<!--                                                matTooltip="{{'pba-settings.mfa-tooltip' | translate}}"-->
<!--                                                matTooltipPosition="right">-->
<!--                                                <span class="mdi mdi-information-outline"></span>-->
<!--                                            </span>-->
<!--                                            </span>-->
<!--                                            <span>-->
<!--                                            {{disk?.pba_info?.settings?.mfa === '' ? ('pba-settings.not-required' | translate) : (disk?.pba_info?.settings?.mfa | uppercase)}}-->
<!--                                            </span>-->
<!--                                        </li>-->
<!--                                        <li>-->
<!--                                            <span class="pba-label">-->
<!--                                            {{'pba-settings.mfa-options' | translate}}-->
<!--                                            <span tabindex="0"-->
<!--                                                attr.aria-label="{{'pba-settings.mfa-options-tooltip' | translate}}"-->
<!--                                                matTooltip="{{'pba-settings.mfa-options-tooltip' | translate}}"-->
<!--                                                matTooltipPosition="right">-->
<!--                                                <span class="mdi mdi-information-outline"></span>-->
<!--                                            </span>-->
<!--                                            </span>-->
<!--                                            <span>-->
<!--                                            {{disk?.pba_info?.settings?.mfa_options === '' ? ('NONE' | translate) : disk?.pba_info?.settings?.mfa_options | titlecase}}-->
<!--                                            </span>-->
<!--                                        </li>-->
<!--                                        <li>-->
<!--                                            <span class="pba-label">-->
<!--                                            {{'pba-settings.enable-remember-me' | translate}}-->
<!--                                            <span tabindex="0"-->
<!--                                                attr.aria-label="{{'pba-settings.enable-remember-me-tooltip' | translate}}"-->
<!--                                                matTooltip="{{'pba-settings.enable-remember-me-tooltip' | translate}}"-->
<!--                                                matTooltipPosition="right">-->
<!--                                                <span class="mdi mdi-information-outline"></span>-->
<!--                                            </span>-->
<!--                                            </span>-->
<!--                                            <span>-->
<!--                                            {{disk?.pba_info?.settings?.enable_remember_me === true ? ('ON' | translate) : ('OFF' | translate) }}-->
<!--                                            </span>-->
<!--                                        </li>-->
<!--                                        <li>-->
<!--                                            <span class="pba-label">-->
<!--                                            {{'pba-settings.allow-tpm' | translate}}-->
<!--                                            <span tabindex="0"-->
<!--                                                attr.aria-label="{{'pba-settings.allow-tpm-tooltip' | translate}}"-->
<!--                                                matTooltip="{{'pba-settings.allow-tpm-tooltip' | translate}}"-->
<!--                                                matTooltipPosition="right">-->
<!--                                                <span class="mdi mdi-information-outline"></span>-->
<!--                                            </span>-->
<!--                                            </span>-->
<!--                                            <span>-->
<!--                                            {{disk?.pba_info?.settings?.tpm === true ? ('ON' | translate) : ('OFF' | translate) }}-->
<!--                                            </span>-->
<!--                                        </li>-->
<!--                                        </ul>-->
<!--                                    </div>-->
<!--                                    </div>-->
<!--                                }-->
<!--                            }-->

<!--                        </mat-card-content>-->
<!--                        </mat-card>-->

<!--                        <mat-card appearance="raised">-->
<!--                            <mat-card-header>-->
<!--                                <mat-card-title><span class="mdi mdi-account title-icon"></span>{{'pba-users.title' | translate}}</mat-card-title>-->
<!--                            </mat-card-header>-->
<!--                            <mat-card-content>-->
<!--                                @for (disk of device.config?.disks; track $index;) {-->
<!--                                    @if (disk?.pba_info?.users) {-->
<!--                                        <mat-table [dataSource]="disk?.pba_info?.users">-->
<!--                                            <ng-container matColumnDef="username">-->
<!--                                                <mat-header-cell *matHeaderCellDef>{{'ADM_UNAME' | translate}}</mat-header-cell>-->
<!--                                                <mat-cell *matCellDef="let pbaUser let i=index">{{pbaUser.username}}</mat-cell>-->
<!--                                            </ng-container>-->

<!--                                            <ng-container matColumnDef="email">-->
<!--                                                <mat-header-cell *matHeaderCellDef>{{'ADM_EMAIL' | translate}}</mat-header-cell>-->
<!--                                                <mat-cell *matCellDef="let pbaUser">{{pbaUser.email}}</mat-cell>-->
<!--                                            </ng-container>-->

<!--                                            <ng-container matColumnDef="administrator">-->
<!--                                                <mat-header-cell *matHeaderCellDef>{{'U_ROLE' | translate}}</mat-header-cell>-->
<!--                                                <mat-cell *matCellDef="let pbaUser">-->
<!--                                                    @if (pbaUser.administrator) {-->
<!--                                                        {{'APU_ADMIN' | translate}}-->
<!--                                                    } @else {-->
<!--                                                        {{'APU_USER' | translate}}-->
<!--                                                    }-->
<!--                                                </mat-cell>-->
<!--                                            </ng-container>-->

<!--                                            <ng-container matColumnDef="mfa">-->
<!--                                                <mat-header-cell *matHeaderCellDef>MFA</mat-header-cell>-->
<!--                                                <mat-cell *matCellDef="let pbaUser">{{pbaUser.mfa}}</mat-cell>-->
<!--                                            </ng-container>-->

<!--                                            <ng-container matColumnDef="mfa_options">-->
<!--                                                <mat-header-cell *matHeaderCellDef>{{'pba-users.mfa_options' | translate}}</mat-header-cell>-->
<!--                                                <mat-cell *matCellDef="let pbaUser">{{pbaUser.mfa_options}}</mat-cell>-->
<!--                                            </ng-container>-->

<!--                                            <mat-header-row *matHeaderRowDef="['username', 'email', 'administrator', 'mfa', 'mfa_options']"></mat-header-row>-->
<!--                                            <mat-row *matRowDef="let user, let i = index; columns: ['username', 'email', 'administrator', 'mfa', 'mfa_options']"></mat-row>-->
<!--                                        </mat-table>-->
<!--                                    }-->
<!--                                }-->
<!--                            </mat-card-content>-->
<!--                        </mat-card>-->
<!--                    </ng-container>-->

                    </ng-container>
                }
<!--                }-->
            </mat-tab>

            @if (haveDataDefenseSubscription) {

                <mat-tab *ngIf="device.config">
                    <ng-template mat-tab-label>
                        <span class="tab-icon">
                          <span class="mdi mdi-database-lock-outline" aria-hidden="true"></span>
                        </span>
                        <span class="tab-title">Data Protections</span>
                    </ng-template>
                    <app-data-protections [license]="device"></app-data-protections>
                </mat-tab>
            }

            @if (haveBitlockerSubscription) {
                <mat-tab>
                    <ng-template mat-tab-label>
                        <span class="tab-icon">
                          <span class="mdi mdi-key" aria-hidden="true"></span>
                        </span>
                        <span class="tab-title">{{'bitlocker-compliance.title' | translate}}</span>
                    </ng-template>

                    <div class="bitlocker-tab-container">
                    <div class="bitlocker-tab-inner-container">

                        @if (getVolsByType(volumes); as volsByType) {
                            @for (volType of [VolumeType.OPERATING_SYSTEM_VOLUME, VolumeType.FIXED_DATA_VOLUME, VolumeType.REMOVABLE_DATA_VOLUME, VolumeType.OTHER]; track volType) {
                                @if (volsByType.get(volType).length > 0) {
                                    <h1>
                                        @switch (volType) {
                                            @case (VolumeType.OPERATING_SYSTEM_VOLUME) {
                                                {{'endpoint-detail.bitlocker-tab.volumes.os' | translate}}
                                            }
                                            @case (VolumeType.FIXED_DATA_VOLUME) {
                                                {{'endpoint-detail.bitlocker-tab.volumes.fixed' | translate}}
                                            }
                                            @case (VolumeType.REMOVABLE_DATA_VOLUME) {
                                                {{'endpoint-detail.bitlocker-tab.volumes.removable' | translate}}
                                            }
                                            @case (VolumeType.OTHER) {
                                                {{'endpoint-detail.bitlocker-tab.volumes.other' | translate}}
                                            }
                                        }
                                    </h1>
                                    @for (volume of volsByType.get(volType); track volume.guid) {
                                        <mat-card class="encrypted-volume-card" appearance="raised">
                                            <mat-card-header>
                                                <mat-card-title>
                                                    <div>
                                                        @if (volume?.label) {
                                                            <span>{{ volume.label }} ({{ volume.mount }}:)</span>
                                                        } @else {
                                                            <span>{{ volume.mount }}:</span>
                                                        }
                                                    </div>
                                                    @if (volume?.volume_encryption?.key_available) {
                                                        <div>
                                                            <app-bitlocker-key-request
                                                                    [endpointName]="device.computer_name"
                                                                    [volume]="volume"
                                                                    [restConfig]="restConfig"></app-bitlocker-key-request>
                                                        </div>
                                                    }
                                                </mat-card-title>
                                                <mat-card-subtitle>
                                                    <div>{{'endpoint-detail.bitlocker-tab.volumes.recovery-key-id' | translate : {keyId: volume?.volume_encryption.key_id}  }}</div>
                                                </mat-card-subtitle>
                                            </mat-card-header>
                                            <mat-card-content>
                                                <table aria-describedby="Endpoints drive information">
                                                    <tbody>
                                                    <tr>
                                                        <th>{{'endpoints.partitions.locked' | translate}}</th>
                                                        <td>{{getLockedDisplay(volume)}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>{{'endpoints.partitions.encryption_flags' | translate}}</th>
                                                        <td>{{getVolumeFlagsDisplay(volume)}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>{{'endpoints.partitions.encryption_type' | translate}}</th>
                                                        <td>{{getVolumeEncryption(volume)}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>{{'endpoints.partitions.status' | translate}}</th>
                                                        <td>{{ getVolumeStatusDisplay(volume) }}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>{{'endpoints.partitions.protectors' | translate}}</th>
                                                        <td>{{volume.volume_encryption.protector_display}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>{{'endpoints.partitions.protection' | translate}}</th>
                                                        <td>{{getVolumeProtectionDisplay(volume)}}</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </mat-card-content>
                                        </mat-card>
                                    }

                                }
                            }
                        }

                        <div *ngIf="bitLockerStatus$ | async as bitLockerStatus" class="bitlocker-status">
                            <div>
                            <h1>{{'endpoints.col.bitlocker-compliance' | translate}}</h1>
                            <mat-card appearance="raised">
                                <div class="overall-bitlocker-status" *ngIf="device.bitlocker_compliance === BitlockerCompliance.NON_COMPLIANT || device.bitlocker_compliance === BitlockerCompliance.COMPLIANT">
                                    <div>{{'bitlocker-compliance.title' | translate}}</div>
                                    <app-d3e-device-compliance [compliant]="device.bitlocker_compliance === BitlockerCompliance.COMPLIANT &&
                                                                             bitLockerStatus.ddCompatible &&
                                                                             bitLockerStatus.osVersionCompatible &&
                                                                             bitLockerStatus.tpmCompatible &&
                                                                             bitLockerStatus.haveNoncompliantOsVolumes &&
                                                                             bitLockerStatus.haveNoncompliantFixedVolumes &&
                                                                             bitLockerStatus.backupToMcCompliant &&
                                                                             bitLockerStatus.startupTypeCompliant"></app-d3e-device-compliance>
                                </div>
                                <div class="bitlocker-compliance-table-wrapper">
                                    <table class="bitlocker-compliance" aria-label="BitLocker compliance information">
                                        <tr>
                                            <th scope="col" class="category">&nbsp;</th>
                                            <th scope="col">Minimum Required</th>
                                            <th scope="col">Endpoint</th>
                                            <th scope="col">Status</th>
                                        </tr>

                                        <tr>
                                            <th scope="row" class="category">Data Defense</th>
                                            <td>{{ MIN_BITLOCKER_VERSION }}</td>
                                            <td>{{device.version}}</td>
                                            <td><app-d3e-device-compliance [compliant]="bitLockerStatus.ddCompatible"></app-d3e-device-compliance></td>
                                        </tr>

                                        <tr>
                                            <th scope="row" class="category">{{'bitlocker-status.operating-system' | translate}}</th>
                                            <td>{{ MIN_BITLOCKER_WINDOWS_VERSION }}</td>
                                            <td>{{device.config?.os_version}}</td>
                                            <td><app-d3e-device-compliance [compliant]="bitLockerStatus.osVersionCompatible"></app-d3e-device-compliance></td>
                                        </tr>

                                        <tr>
                                            <th scope="row" class="category">TPM</th>
                                            <td>{{ TPM_MIN_VERSION }}</td>
                                            <td>{{bitLockerStatus.tpm}}</td>
                                            <td><app-d3e-device-compliance [compliant]="bitLockerStatus.tpmCompatible"></app-d3e-device-compliance></td>
                                        </tr>

                                        <tr>
                                            <th scope="row" class="category">{{'bitlocker-status.os-drive-encryption-method' | translate}}</th>
                                            <td>{{bitLockerStatus.policyOSDriveEncryption}}</td>
                                            <td>{{bitLockerStatus.deviceOSDriveEncryption}}</td>
                                            <td><app-d3e-device-compliance [compliant]="bitLockerStatus.haveNoncompliantOsVolumes"></app-d3e-device-compliance></td>
                                        </tr>

                                        <tr>
                                            <th scope="row" class="category">{{'bitlocker-status.fixed-drive-encryption-method' | translate}}</th>
                                            <td>{{bitLockerStatus.policyFixedDriveEncryption}}</td>
                                            <td>{{bitLockerStatus.deviceFixedDriveEncryption}}</td>
                                            <td><app-d3e-device-compliance [compliant]="bitLockerStatus.haveNoncompliantFixedVolumes"></app-d3e-device-compliance></td>
                                        </tr>

                                        <tr>
                                            <th scope="row" class="category">{{'bitlocker-status.keys-backed-up-to-mc' | translate}}</th>
                                            <td>
                                                <span *ngIf="bitLockerStatus.policyBackupToMc">{{'YES' | translate}}</span>
                                                <span *ngIf="!bitLockerStatus.policyBackupToMc">{{'NO' | translate}}</span>
                                            </td>
                                            <td>
                                                <span *ngIf="bitLockerStatus.allVolumeKeysBackedUp">{{'YES' | translate}}</span>
                                                <span *ngIf="!bitLockerStatus.allVolumeKeysBackedUp">{{'NO' | translate}}</span>
                                            </td>
                                            <td><app-d3e-device-compliance [compliant]="bitLockerStatus.backupToMcCompliant"></app-d3e-device-compliance></td>
                                        </tr>
    <!--
                                        <tr>
                                            <th class="category">{{'bitlocker-status.keys-backed-up-to-ad' | translate}}</th>
                                            <td>
                                                <span *ngIf="bitLockerStatus.policyBackupToAd">{{'YES' | translate}}</span>
                                                <span *ngIf="!bitLockerStatus.policyBackupToAd">{{'NO' | translate}}</span>
                                            </td>
                                            <td>
                                                <span *ngIf="bitLockerStatus.backupToAd">{{'YES' | translate}}</span>
                                                <span *ngIf="!bitLockerStatus.backupToAd">{{'NO' | translate}}</span>
                                            </td>
                                            <td><app-d3e-device-compliance [compliant]="bitLockerStatus.backupoAdCompliant"></app-d3e-device-compliance></td>
                                        </tr>-->

                                        <tr>
                                            <th scope="row" class="category">{{'bitlocker-status.startup-auth' | translate}}</th>
                                            <td>{{bitLockerStatus.policyStartupTypeDisplay}}</td>
                                            <td>{{bitLockerStatus.startupTypeDisplay}}</td>
                                            <td><app-d3e-device-compliance [compliant]="bitLockerStatus.startupTypeCompliant"></app-d3e-device-compliance></td>
                                        </tr>
                                    </table>
                                </div>
                            </mat-card>
                            </div>
                        </div>
                    </div>
                    </div>
                </mat-tab>
            }

            @if (haveDataDefenseSubscription) {
                <mat-tab *ngIf="device.config">
                    <ng-template mat-tab-label>
                        <span class="tab-icon">
                          <span class="mdi mdi-alert-outline" aria-hidden="true"></span>
                        </span>
                        <span class="tab-title">{{'THREAT_SENSORS' | translate}}</span>
                    </ng-template>
                    <div class="auth-title-wrapper">
                        <div *ngIf="!networkSensorEnabled" class="auth-sub-title">Network sensor is disabled. This information is no longer being updated.</div>
                    </div>

                    <app-threat-sensors [deceptionFiles]="device.config.deceptionFiles"
                                        [deceptionUrls]="device.config.deceptionUrls"
                                        [networks]="device.config.networks"
                                        [state]="device.state"
                                        [sensorConfigs]="device.config.sensorConfigs"></app-threat-sensors>
                </mat-tab>
            }

            @if (haveDataDefenseSubscription || isAgentInstalled(device)) {
                <mat-tab>
                    <ng-template mat-tab-label>
                        <span class="tab-icon">
                          <span class="mdi mdi-fingerprint" aria-hidden="true"></span>
                        </span>
                        <span class="tab-title">{{fAuthentication}}</span>
                    </ng-template>
                    @if(this.configurationService.showAgentMenus) {
                        <div class="auth-card-stack">

                        @if (isAgentInstalled(device)) {
                            <mat-card class="bottom-card">
                                <mat-card-header>
                                    <mat-card-title>{{'endpoints.pba-section-title' | translate}}</mat-card-title>
                                </mat-card-header>
                                <mat-card-header>
                                    <mat-card-title class="sub-title">
                                        {{'TITLE_USERS' | translate}}
                                    </mat-card-title>
                                </mat-card-header>
                                <div class="table-indent">
                                    <div class="users-table">
                                        <!-- Header row -->
                                        <div class="table-header">{{'ADM_UNAME' | translate}}</div>
                                        <div class="table-header">{{'ADM_EMAIL' | translate}}</div>
                                        <div class="table-header">{{'APU_ROLE' | translate}}</div>
                                        <div class="table-header">{{'U_STATUS' | translate}}</div>

                                        @if (!hasPbaUsers(device)) {
                                            <div class="table-cell">{{'endpoints.no-users' | translate}}</div>
                                            <div class="table-cell"></div>
                                            <div class="table-cell"></div>
                                        } @else {
                                            @for (pbaUser of getPbaUsers(device); track pbaUser.id) {
                                                <div class="table-cell">{{ pbaUser.username }}</div>
                                                <div class="table-cell">{{ pbaUser.email }}</div>
                                                <div class="table-cell">
                                                    @switch (pbaUser.role) {
                                                        @case (ProductUserRole.Invalid) {
                                                            {{'INVALID' | translate}}
                                                        }
                                                        @case (ProductUserRole.User) {
                                                            {{ 'APU_USER' | translate }}
                                                        }
                                                        @case (ProductUserRole.UserAdmin) {
                                                            {{'APU_USERADMIN' | translate}}
                                                        }
                                                        @case (ProductUserRole.Admin) {
                                                            {{ 'APU_ADMIN' | translate }}
                                                        }
                                                        @default {
                                                            {{'unknown' | translate}}
                                                        }
                                                    }
                                                </div>
                                                <div class="table-cell">
                                                    @switch (pbaUser.action) {
                                                        @case (ConsoleAction.ADD_PBA_USER) {
                                                            {{'endpoint.user.pending-add' | translate}}
                                                        }
                                                        @case (ConsoleAction.EDIT_PBA_USER) {
                                                            {{'endpoint.user.pending-modify' | translate}}
                                                        }
                                                        @case (ConsoleAction.REMOVE_PBA_USER) {
                                                            {{'endpoint.user.pending-removal' | translate}}
                                                        }
                                                        @default {
                                                            -
                                                        }
                                                    }
                                                </div>
                                            }
                                        }
                                    </div>
                                </div>
                                <mat-card-header>
                                    <mat-card-title class="sub-title">
                                        {{'endpoints.enrollment-section-title' | translate}}
                                    </mat-card-title>
                                </mat-card-header>
                                <div class="table-indent">
                                    <div class="enroll-table">

                                        <!-- Header row -->
                                        <div class="table-header">{{'endpoints.enrollment-code-id' | translate}}</div>
                                        <div class="table-header">{{'endpoints.enrollment-uses-left' | translate}}</div>
                                        <div class="table-header">{{'EXPIRES' | translate}}</div>
                                        <div class="table-header">{{'U_STATUS' | translate}}</div>

                                        @if (!hasPbaEnrollmentCodes(device)) {
                                            <div class="table-cell">{{'endpoints-no-enrollment-codes' | translate}}</div>
                                            <div class="table-cell"></div>
                                            <div class="table-cell"></div>
                                        } @else {
                                            @for (enrollment of getPbaEnrollmentCodes(device) || []; track enrollment.id) {
                                                @if (enrollment.enroll_code_id) {
                                                    <div class="table-cell">{{ enrollment.enroll_code_id }}</div>
                                                }
                                                @else {
                                                    <div class="table-cell">No ID set</div>
                                                }
                                                <div class="table-cell">
                                                    {{ enrollment.usages_remaining  === -1 ? 'Unlimited' : enrollment.usages_remaining }}
                                                </div>
                                                <div class="table-cell">
                                                    {{ isPerpetualExpiration(enrollment.expires_dttm)
                                                        ? 'Never'
                                                        : (enrollment.expires_dttm | date:'shortDate':'UTC') }}
                                                </div>
                                                <div class="table-cell">
                                                    @switch (enrollment.action) {
                                                        @case (ConsoleAction.ADD_ENROLLCODES_PBA) {
                                                            {{'endpoint.user.pending-add' | translate}}
                                                        }
                                                        @default {
                                                            @if (device.has_pending_pba_remove_all) {
                                                                {{'endpoint.user.pending-removal' | translate}}
                                                            } @else {
                                                                -
                                                            }
                                                        }
                                                    }
                                                </div>
                                            }
                                        }
                                    </div>
                                </div>
                            </mat-card>
                        }
                        @if (isAgentInstalled(device)) {
                            <mat-card class="bottom-card">
                                <mat-card-header>
                                    <mat-card-title class="bottom-title">
                                        {{'endpoints.fde-section-title' | translate}}
                                    </mat-card-title>
                                </mat-card-header>

                                <mat-card-header>
                                    <mat-card-title class="sub-title">
                                        {{'TITLE_USERS' | translate}}
                                    </mat-card-title>
                                </mat-card-header>
                                <div class="table-indent">
                                    <div class="users-table">
                                        <!-- Header row -->
                                        <div class="table-header">{{'ADM_UNAME' | translate}}</div>
                                        <div class="table-header">{{'ADM_EMAIL' | translate}}</div>
                                        <div class="table-header">{{'APU_ROLE' | translate}}</div>
                                        <div class="table-header">{{'U_STATUS' | translate}}</div>

                                        @if (!hasFdeUsers(device)) {
                                            <div class="table-cell">{{'endpoints.no-users' | translate}}</div>
                                            <div class="table-cell"></div>
                                            <div class="table-cell"></div>
                                        } @else {
                                            @for (fdeUser of getFdeUsers(device) || []; track fdeUser.id) {
                                                <div class="table-cell">{{ fdeUser.username }}</div>
                                                <div class="table-cell">{{ fdeUser.email }}</div>
                                                <div class="table-cell">
                                                    @switch (fdeUser.role) {
                                                        @case (ProductUserRole.Invalid) {
                                                            {{'INVALID' | translate}}
                                                        }
                                                        @case (ProductUserRole.User) {
                                                            {{ 'APU_USER' | translate }}
                                                        }
                                                        @case (ProductUserRole.UserAdmin) {
                                                            {{'APU_USERADMIN' | translate}}
                                                        }
                                                        @case (ProductUserRole.Admin) {
                                                            {{ 'APU_ADMIN' | translate }}
                                                        }
                                                        @default {
                                                            {{'unknown' | translate}}
                                                        }
                                                    }
                                                </div>
                                                <div class="table-cell">
                                                    @switch (fdeUser.action) {
                                                        @case (ConsoleAction.ADD_FDE_USER) {
                                                        {{'endpoint.user.pending-add' | translate}}
                                                        }
                                                        @case (ConsoleAction.EDIT_FDE_USER) {
                                                        {{'endpoint.user.pending-modify' | translate}}
                                                        }
                                                        @case (ConsoleAction.REMOVE_FDE_USER) {
                                                        {{'endpoint.user.pending-removal' | translate}}
                                                        }
                                                        @default {
                                                        -
                                                        }
                                                    }
                                                </div>
                                            }
                                        }
                                    </div>
                                </div>
                                <mat-card-header>
                                    <mat-card-title class="sub-title">
                                    {{'endpoints.enrollment-section-title' | translate}}
                                    </mat-card-title>
                                </mat-card-header>
                                <div class="table-indent">
                                    <div class="enroll-table">
                                        <!-- Header row -->
                                        <div class="table-header">{{'endpoints.enrollment-code-id' | translate}}</div>
                                        <div class="table-header">{{'endpoints.enrollment-uses-left' | translate}}</div>
                                        <div class="table-header">{{'EXPIRES' | translate}}</div>
                                        <div class="table-header">{{'U_STATUS' | translate}}</div>

                                        @if (!hasFdeEnrollmentCodes(device)) {
                                            <div class="table-cell">{{'endpoints-no-enrollment-codes' | translate}}</div>
                                            <div class="table-cell"></div>
                                            <div class="table-cell"></div>
                                        } @else {
                                            @for (enrollment of getFdeEnrollmentCodes(device) || []; track enrollment.id) {
                                                @if (enrollment.enroll_code_id) {
                                                    <div class="table-cell">{{ enrollment.enroll_code_id }}</div>
                                                }
                                                @else {
                                                    <div class="table-cell">No ID set</div>
                                                }
                                                <div class="table-cell">
                                                    {{ enrollment.usages_remaining  === -1 ? 'Unlimited' : enrollment.usages_remaining }}
                                                </div>
                                                <div class="table-cell">
                                                    {{ isPerpetualExpiration(enrollment.expires_dttm)
                                                        ? 'Never'
                                                        : (enrollment.expires_dttm | date:'shortDate':'UTC') }}
                                                </div>
                                                <div class="table-cell">
                                                    @switch (enrollment.action) {
                                                        @case (ConsoleAction.ADD_ENROLLCODES_FDE) {
                                                            {{'endpoint.user.pending-add' | translate}}
                                                        }
                                                        @default {
                                                            @if (device.has_pending_fde_remove_all) {
                                                                {{'endpoint.user.pending-removal' | translate}}
                                                            } @else {
                                                                -
                                                            }
                                                        }
                                                    }
                                                </div>
                                            }
                                        }
                                    </div>
                                </div>
                            </mat-card>
                        }
                        </div>
                    }
                    @if (haveDataDefenseSubscription) {
                        <div class="auth-table-wrapper">
                            <mat-table [dataSource]="authModesDisplayOrderFiltered" class="auth-table">
                                <ng-container matColumnDef="method">
                                    <th scope="col" mat-header-cell *matHeaderCellDef><span>{{ fMethod }}</span></th>
                                    <td mat-cell *matCellDef="let mode">
                                        <div class="icon-wrapper">
                                    <span class="auth-icon"
                                    [ngSwitch]="mode"
                                    [ngClass]="{'active-auth-configuration': getAuthModeConfigured(mode) === fYes, 'inactive-auth-configuration': getAuthModeConfigured(mode) === fNo}">
                                    <span *ngSwitchCase="1">
                                        <span class="mdi mdi-fingerprint"></span>
                                    </span>
                                    <span *ngSwitchCase="2">
                                        <span class="mdi mdi-face-recognition"></span>
                                    </span>
                                    <span *ngSwitchCase="3">
                                        <span class="mdi mdi-cellphone-key"></span>
                                    </span>
                                    <span *ngSwitchCase="5">
                                        <span class="mdi mdi-dialpad"></span>
                                    </span>
                                    <span *ngSwitchCase="7">
                                        <!-- src attribute 3is overriden in css using content: url(...)-->
                                        <img alt="Cisco Duo Image" src="/assets/duo_d_gray.png" class="cisco-duo-image">
                                    </span>
                                    <span *ngSwitchCase="8">
                                        <span class="mdi mdi-smart-card-outline"></span>
                                    </span>
                                    <span *ngSwitchCase="14">
                                        <span class="mdi mdi-shield-lock-outline"></span>
                                    </span>
                                    <span *ngIf="getAuthModeState(mode) === fYes" class="mdi mdi-check-circle"
                                        [ngClass]="{'default-auth-icon': getAuthModeState(mode) === fYes}">
                                    </span>
                                </span>
                                            <span class="icon-text-wrapper">
                                    <div class="icon-text">{{ getAuthModeText(mode) }} </div>
                                    <div class="icon-description">{{ getAuthModeDescription(mode) }} </div>
                                </span>
                                        </div>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="active">
                                    <th scope="col" mat-header-cell *matHeaderCellDef>{{ fDefault }}</th>
                                    <td mat-cell class="center-text" *matCellDef="let mode"> {{ getAuthModeState(mode) }}</td>
                                </ng-container>

                                <ng-container matColumnDef="configured">
                                    <th scope="col" mat-header-cell *matHeaderCellDef>{{ fConfig }}</th>
                                    <td mat-cell class="center-text" *matCellDef="let mode"> {{ getAuthModeConfigured(mode) }}
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="authColumns"></tr>
                                <tr mat-row *matRowDef="let myRowData; columns: authColumns"></tr>
                            </mat-table>
                        </div>
                    }
                </mat-tab>
            }

            @if (haveDataDefenseSubscription || isAgentInstalled(device)) {
                <mat-tab>
                    <ng-template mat-tab-label>
                        <span class="tab-icon">
                          <span class="mdi mdi-application-settings" aria-hidden="true"></span>
                        </span>
                        <span class="tab-title">{{'D3E_SETTINGS' | translate}}</span>
                    </ng-template>
                    @if(isAgentInstalled(device)) {
                    <div class="policy-sections-grid">
                        <mat-card class="policy-section large-section" appearance="raised">
                            <mat-card-header>
                                <mat-card-title>
                                    <span class="mdi mdi-application-settings card-title-icon"></span>Endpoint Settings
                                </mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <div class="content-wrapper">
                                    <div class="settings-wrapper">
                                        <span class="setting-label">
                                            {{ 'ALC_POLICY' | translate }}
                                            <span matTooltip="{{'ALC_POLICY_TIP' | translate}}" matTooltipPosition="right">
                                                <span class="mdi mdi-information-outline"></span>
                                            </span>
                                        </span>
                                        <span class="setting-value">
                                            @if (user$ | async; as user) {
                                                @if (user.role === UserRole.ADMIN) {
                                                    <a [routerLink]="['/policy', effectivePolicy?.policy_id]"
                                                    [queryParams]="{selectedOrgId: effectivePolicy?.effective_group_id}">
                                                        {{ effectivePolicy?.policy_name }}
                                                    </a>
                                                } @else {
                                                    {{ effectivePolicy?.policy_name }}
                                                }
                                            }
                                        </span>
                                    </div>
                                    <div class="settings-wrapper">
                                        <span class="setting-label">
                                            {{ 'ALC_POLICY_UPDATE' | translate }}
                                            <span matTooltip="{{'ALC_POLICY_TIPB' | translate}}" matTooltipPosition="right">
                                                <span class="mdi mdi-information-outline"></span>
                                            </span>
                                        </span>
                                        <span class="setting-value">{{ displayDate(effectivePolicy?.last_policy_dttm) }}</span>
                                    </div>
                                    <div class="settings-wrapper">
                                        <span class="setting-label">
                                            {{ fConfig }}
                                            <span matTooltip="{{'ALC_CONFIG_TIP' | translate}}" matTooltipPosition="right">
                                                <span class="mdi mdi-information-outline"></span>
                                            </span>
                                        </span>
                                        <span class="setting-value">{{ displayDate(device.last_config_dttm) }}</span>
                                    </div>
                                    <div class="settings-wrapper">
                                        <span class="setting-label">
                                            {{ 'ALC_SYNC' | translate }}
                                            <span matTooltip="{{'ALC_SYNC_TIP' | translate}}" matTooltipPosition="right">
                                                <span class="mdi mdi-information-outline"></span>
                                            </span>
                                        </span>
                                        <span class="setting-value">{{ device.config ? getInterval(device.config.syncInterval) : 'No Configuration' }}</span>
                                    </div>
                                    <div *ngIf="device.config?.syncIntervalMetered" class="settings-wrapper">
                                        <span class="setting-label">
                                            {{ 'ALC_SYNC_METER' | translate }}
                                            <span matTooltip="{{'ALC_SYNC_TIPB' | translate}}" matTooltipPosition="right">
                                                <span class="mdi mdi-information-outline"></span>
                                            </span>
                                        </span>
                                        <span class="setting-value">{{ device.config ? getInterval(device.config.syncIntervalMetered) : 'No Configuration' }}</span>
                                    </div>
                                    @if(haveDataDefenseSubscription) {
                                        <div class="settings-wrapper">
                                            <span class="setting-label">
                                                {{'PRE_AUTH_FILE_ACCESS_FREQ_COUNT' | translate}}
                                                <span matTooltip="{{'PRE_AUTH_FILE_ACCESS_COUNT_TOOLTIP' | translate}}">
                                                    <span class="mdi mdi-information-outline"></span>
                                                </span>
                                            </span>
                                            <span class="setting-value" *ngIf="device?.config?.preAuthFileAccessCount !== null; else noFiles">
                                            {{ device.config.preAuthFileAccessCount | i18nPlural:filePluralMapping }}
                                            </span>
                                            <ng-template #noFiles><span class="setting-value">N/A</span></ng-template>
                                        </div>
                                        <div class="settings-wrapper">
                                            <span class="setting-label">
                                                {{'PRE_AUTH_FILE_ACCESS_COUNT' | translate}}
                                                <span matTooltip="{{'PRE_AUTH_FILE_ACCESS_COUNT_TOOLTIP' | translate}}">
                                                    <span class="mdi mdi-information-outline"></span>
                                                </span>
                                            </span>
                                            <span class="setting-value" *ngIf="device?.config?.preAuthFileAccessTimeout !== null && device?.config?.preAuthFileAccessTimeout > 0; else unlimited">
                                            {{ getIntervalMinutes(device.config.preAuthFileAccessTimeout) }}
                                            </span>
                                            <ng-template #unlimited><span class="setting-value">Unlimited</span></ng-template>
                                        </div>
                                        <div class="settings-wrapper">
                                            <span class="setting-label">
                                                {{'PRE_AUTH_FILE_ACCESS_FREQ_TYPE' | translate}}
                                                <span matTooltip="{{'FORCE_PRE_AUTH_VALUES_TOOLTIP' | translate}}">
                                                    <span class="mdi mdi-information-outline"></span>
                                                </span>
                                            </span>
                                            <span class="setting-value">
                                            {{ getReAuthFrequencyLabel(device.config?.forcePreAuthValues) }}
                                            </span>
                                        </div>
                                        <div class="settings-wrapper">
                                            <span class="setting-label">
                                                {{'policy.ransomware.sensitivity-min' | translate}}
                                                <span matTooltip="{{ 'policy.ransomware.sensitivity-tooltip' | translate}}">
                                                    <span class="mdi mdi-information-outline"></span>
                                                </span>
                                            </span>
                                            <span class="setting-value">
                                            {{ device.config?.ransomwareSensitivityMin }}
                                            </span>
                                        </div>
                                        <div class="settings-wrapper">
                                            <span class="setting-label">
                                                {{'policy.ransomware.sensitivity-max' | translate}}
                                                <span matTooltip="{{ 'policy.ransomware.sensitivity-tooltip' | translate}}">
                                                    <span class="mdi mdi-information-outline"></span>
                                                </span>
                                            </span>
                                            <span class="setting-value">
                                            {{ device.config?.ransomwareSensitivityMax }}
                                            </span>
                                        </div>

                                        <div class="settings-wrapper">
                                            <span class="setting-label">
                                                {{'policy.ransomware.feature-mask.label' | translate}}
                                                <span matTooltip="{{ 'policy.ransomware.feature-mask.tooltip' | translate}}">
                                                    <span class="mdi mdi-information-outline"></span>
                                                </span>
                                            </span>
                                            <span class="setting-value">
                                            {{ getFeatureMask(device.config?.ransomwareFeatureMask) }}
                                            </span>
                                        </div>
                                    }
                                </div>
                            </mat-card-content>
                        </mat-card>
                        <!-- 1 -->
                        @if(this.configurationService.showAgentMenus) {
                            @if (isAgentInstalled(device)) {
                                <mat-card class="policy-section" appearance="raised">
                                    <mat-card-header class="policy-card-header">
                                        <mat-card-title>
                                            <span class="policy-compliance-header">
                                                PBA Policy Compliance
                                            </span>
                                        </mat-card-title>
                                        <div class="compliance-container">
                                            <app-d3e-device-compliance
                                                [compliant]="getPbaPolicyCompliance() === PolicyCompliance.COMPLIANT"
                                                [isNA]="
                                                    (isAgentInstalled(device) && !device?.pbaAuthorization) ||
                                                    getPbaPolicyCompliance() === PolicyCompliance.UNKNOWN
                                                ">
                                            </app-d3e-device-compliance>
                                        </div>
                                    </mat-card-header>
                                    <mat-card-content>
                                        <div class="four-col-table">
                                            <!-- Header -->
                                            <div class="header"></div>
                                            <div class="header">Policy</div>
                                            <div class="header">Endpoint</div>
                                            <div class="header right-col">Status</div>

                                            <!-- Row 1 -->
                                            <div>{{'pba-settings.failed-logins-before-lockout' | translate}}</div>
                                            <div>{{ effectivePolicy?.policy?.pbaSettings?.failedLoginsBeforeLockout ?? 'N/A' }}</div>
                                            <div>{{ pbaSettings?.failed_logins_before_lockout ?? 'N/A' }}</div>
                                            <div>
                                                <app-policy-compliance-status
                                                    [category]="getPolicyCompliance(
                                                        effectivePolicy?.policy?.pbaSettings?.failedLoginsBeforeLockout,
                                                        pbaSettings?.failed_logins_before_lockout
                                                    )">
                                                </app-policy-compliance-status>
                                            </div>

                                            <!-- Row 2 -->
                                            <div>{{'pba-settings.failed-logins-before-erase' | translate}}</div>
                                            <div>{{ effectivePolicy?.policy?.pbaSettings?.failedLoginsBeforeErase ?? 'N/A' }}</div>
                                            <div>{{ pbaSettings?.failed_logins_before_erase ?? 'N/A' }}</div>
                                            <div>
                                                <app-policy-compliance-status
                                                    [category]="getPolicyCompliance(
                                                        effectivePolicy?.policy?.pbaSettings?.failedLoginsBeforeErase,
                                                        pbaSettings?.failed_logins_before_erase
                                                    )">
                                                </app-policy-compliance-status>
                                            </div>

                                            <!-- Row 3 -->
                                            <div>{{'pba-settings.password-history' | translate}}</div>
                                            <div>{{ effectivePolicy?.policy?.pbaSettings?.passwordHistory ?? 'N/A' }}</div>
                                            <div>{{ pbaSettings?.password_history ?? 'N/A' }}</div>
                                            <div>
                                                <app-policy-compliance-status
                                                    [category]="getPolicyCompliance(
                                                        effectivePolicy?.policy?.pbaSettings?.passwordHistory,
                                                        pbaSettings?.password_history
                                                    )">
                                                </app-policy-compliance-status>
                                            </div>

                                            <!-- Row 4 -->
                                            <div>{{'pba-settings.password-min-length' | translate}}</div>
                                            <div>{{ effectivePolicy?.policy?.pbaSettings?.passwordMin ?? 'N/A' }}</div>
                                            <div>{{ pbaSettings?.password_min ?? 'N/A' }}</div>
                                            <div>
                                                <app-policy-compliance-status
                                                    [category]="getPolicyCompliance(
                                                        effectivePolicy?.policy?.pbaSettings?.passwordMin,
                                                        pbaSettings?.password_min
                                                    )">
                                                </app-policy-compliance-status>
                                            </div>

                                            <!-- Row 5 -->
                                            <div>{{'pba-settings.mfa' | translate}}</div>
                                            <div>{{ effectivePolicy?.policy?.pbaSettings?.mfa ?? 'N/A' }}</div>
                                            <div>{{ pbaSettings?.mfa_required ?? 'N/A' }}</div>
                                            <div>
                                                <app-policy-compliance-status
                                                    [category]="getPolicyCompliance(
                                                        effectivePolicy?.policy?.pbaSettings?.mfa,
                                                        pbaSettings?.mfa_required
                                                    )">
                                                </app-policy-compliance-status>
                                            </div>

                                            <!-- Row 6 -->
                                            <div>{{'pba-settings.mfa-options' | translate}}</div>
                                            <div>{{ effectivePolicy?.policy?.pbaSettings?.mfaOptions ?? 'N/A' }}</div>
                                            <div>{{ pbaSettings?.mfa_option ?? 'N/A' }}</div>
                                            <div>
                                                <app-policy-compliance-status
                                                    [category]="getPolicyCompliance(
                                                        effectivePolicy?.policy?.pbaSettings?.mfaOptions,
                                                        pbaSettings?.mfa_option
                                                    )">
                                                </app-policy-compliance-status>
                                            </div>

                                            <!-- Row 7 -->
                                            <div>{{'pba-settings.enable-remember-me' | translate}}</div>
                                            <div>
                                                {{
                                                    effectivePolicy?.policy?.pbaSettings?.enableRememberMe === true
                                                        ? ('ON' | translate)
                                                        : effectivePolicy?.policy?.pbaSettings?.enableRememberMe === false
                                                            ? ('OFF' | translate)
                                                            : 'N/A'
                                                }}
                                            </div>
                                            <div>
                                                {{
                                                    pbaSettings?.enable_remember_me === true
                                                        ? ('ON' | translate)
                                                        : pbaSettings?.enable_remember_me === false
                                                            ? ('OFF' | translate)
                                                            : 'N/A'
                                                }}
                                            </div>
                                            <div>
                                                <app-policy-compliance-status
                                                    [category]="getPolicyCompliance(
                                                        effectivePolicy?.policy?.pbaSettings?.enableRememberMe,
                                                        pbaSettings?.enable_remember_me
                                                    )">
                                                </app-policy-compliance-status>
                                            </div>

                                            <!-- TPM AUTO not set up for CLI currently, maybe in future -->
                                            <!-- Row 8 -->
                                            <!-- <div>{{'pba-settings.allow-tpm' | translate}}</div>
                                            <div>
                                                {{
                                                    effectivePolicy?.policy?.pbaSettings?.allowTPM === true
                                                        ? ('ON' | translate)
                                                        : effectivePolicy?.policy?.pbaSettings?.allowTPM === false
                                                            ? ('OFF' | translate)
                                                            : 'N/A'
                                                }}
                                            </div>
                                            <div>
                                                {{
                                                    pbaSettings?.tpm_auto === true
                                                        ? ('ON' | translate)
                                                        : pbaSettings?.tpm_auto === false
                                                            ? ('OFF' | translate)
                                                            : 'N/A'
                                                }}
                                            </div>
                                            <div>
                                                <app-policy-compliance-status
                                                    [category]="getPolicyCompliance(
                                                        effectivePolicy?.policy?.pbaSettings?.allowTPM,
                                                        pbaSettings?.tpm_auto
                                                    )">
                                                </app-policy-compliance-status>
                                            </div> -->

                                            <!-- Row 9 -->
                                            <div>{{'pba-settings.smartcard-login-enabled' | translate}}</div>
                                            <div>
                                                {{
                                                    effectivePolicy?.policy?.pbaSettings?.smartcardLoginEnabled === true
                                                        ? ('ON' | translate)
                                                        : effectivePolicy?.policy?.pbaSettings?.smartcardLoginEnabled === false
                                                            ? ('OFF' | translate)
                                                            : 'N/A'
                                                }}
                                            </div>
                                            <div>
                                                {{
                                                    pbaSettings?.smartcard_login_enabled === true
                                                        ? ('ON' | translate)
                                                        : pbaSettings?.smartcard_login_enabled === false
                                                            ? ('OFF' | translate)
                                                            : 'N/A'
                                                }}
                                            </div>
                                            <div>
                                                <app-policy-compliance-status
                                                    [category]="getPolicyCompliance(
                                                        effectivePolicy?.policy?.pbaSettings?.smartcardLoginEnabled,
                                                        pbaSettings?.smartcard_login_enabled
                                                    )">
                                                </app-policy-compliance-status>
                                            </div>

                                            <!-- Row 10 -->
                                            <div>{{'pba-settings.security-key-login-enabled' | translate}}</div>
                                            <div>
                                                {{
                                                    effectivePolicy?.policy?.pbaSettings?.securityKeyLoginEnabled === true
                                                        ? ('ON' | translate)
                                                        : effectivePolicy?.policy?.pbaSettings?.securityKeyLoginEnabled === false
                                                            ? ('OFF' | translate)
                                                            : 'N/A'
                                                }}
                                            </div>
                                            <div>
                                                {{
                                                    pbaSettings?.security_key_login_enabled === true
                                                        ? ('ON' | translate)
                                                        : pbaSettings?.security_key_login_enabled === false
                                                            ? ('OFF' | translate)
                                                            : 'N/A'
                                                }}
                                            </div>
                                            <div>
                                                <app-policy-compliance-status
                                                    [category]="getPolicyCompliance(
                                                        effectivePolicy?.policy?.pbaSettings?.securityKeyLoginEnabled,
                                                        pbaSettings?.security_key_login_enabled
                                                    )">
                                                </app-policy-compliance-status>
                                            </div>
                                        </div>
                                    </mat-card-content>
                                </mat-card>
                            }
                            @if (isAgentInstalled(device)) {
                            <!-- 2 -->
                                <mat-card class="policy-section" appearance="raised">
                                    <mat-card-header class="policy-card-header">
                                        <mat-card-title>
                                            <span class="policy-compliance-header">
                                                FDE Policy Compliance
                                            </span>
                                        </mat-card-title>
                                        <div class="compliance-container">
                                            <app-d3e-device-compliance
                                                [compliant]="getFdePolicyCompliance() === PolicyCompliance.COMPLIANT"
                                                [isNA]="getFdePolicyCompliance() === PolicyCompliance.UNKNOWN ||
                                                    (isAgentInstalled(device) && !device?.fdeAuthorization)">
                                            </app-d3e-device-compliance>
                                        </div>
                                    </mat-card-header>
                                    <mat-card-content>
                                        <div class="four-col-table">
                                            <!-- Header -->
                                            <div class="header"></div>
                                            <div class="header">Policy</div>
                                            <div class="header">Endpoint</div>
                                            <div class="header right-col">Status</div>

                                            <!-- Row 1 -->
                                            <div>{{'pba-settings.failed-logins-before-lockout' | translate}}</div>
                                            <div>{{ effectivePolicy?.policy?.fdeSettings?.failedLoginsBeforeLockout ?? 'N/A' }}</div>
                                            <div>{{ fdeSettings?.failed_logins_before_lockout ?? 'N/A' }}</div>
                                            <div>
                                            <app-policy-compliance-status
                                                [category]="getPolicyCompliance(
                                                    effectivePolicy?.policy?.fdeSettings?.failedLoginsBeforeLockout,
                                                    fdeSettings?.failed_logins_before_lockout
                                                )">
                                            </app-policy-compliance-status>
                                            </div>

                                            <!-- Row 2 -->
                                            <div>{{'pba-settings.failed-logins-before-erase' | translate}}</div>
                                            <div>{{ effectivePolicy?.policy?.fdeSettings?.failedLoginsBeforeErase ?? 'N/A' }}</div>
                                            <div>{{ fdeSettings?.failed_logins_before_erase ?? 'N/A' }}</div>
                                            <div>
                                                <app-policy-compliance-status
                                                    [category]="getPolicyCompliance(
                                                        effectivePolicy?.policy?.fdeSettings?.failedLoginsBeforeErase,
                                                        fdeSettings?.failed_logins_before_erase
                                                    )">
                                                </app-policy-compliance-status>
                                            </div>

                                            <!-- Row 3 -->
                                            <div>{{'pba-settings.password-history' | translate}}</div>
                                            <div>{{ effectivePolicy?.policy?.fdeSettings?.passwordHistory ?? 'N/A' }}</div>
                                            <div>{{ fdeSettings?.password_history ?? 'N/A' }}</div>
                                            <div>
                                                <app-policy-compliance-status
                                                    [category]="getPolicyCompliance(
                                                        effectivePolicy?.policy?.fdeSettings?.passwordHistory,
                                                        fdeSettings?.password_history
                                                    )">
                                                </app-policy-compliance-status>
                                            </div>

                                            <!-- Row 4 -->
                                            <div>{{'pba-settings.password-min-length' | translate}}</div>
                                            <div>{{ effectivePolicy?.policy?.fdeSettings?.passwordMin ?? 'N/A' }}</div>
                                            <div>{{ fdeSettings?.password_min ?? 'N/A' }}</div>
                                            <div>
                                                <app-policy-compliance-status
                                                    [category]="getPolicyCompliance(
                                                        effectivePolicy?.policy?.fdeSettings?.passwordMin,
                                                        fdeSettings?.password_min
                                                    )">
                                                </app-policy-compliance-status>
                                            </div>

                                            <!-- Row 5 -->
                                            <div>{{'pba-settings.enable-remember-me' | translate}}</div>
                                            <div>
                                                {{
                                                    effectivePolicy?.policy?.fdeSettings?.enableRememberMe === true
                                                        ? ('ON' | translate)
                                                        : effectivePolicy?.policy?.fdeSettings?.enableRememberMe === false
                                                            ? ('OFF' | translate)
                                                            : 'N/A'
                                                }}
                                            </div>
                                            <div>
                                                {{
                                                    fdeSettings?.enable_remember_me === true
                                                        ? ('ON' | translate)
                                                        : fdeSettings?.enable_remember_me === false
                                                            ? ('OFF' | translate)
                                                            : 'N/A'
                                                }}
                                            </div>
                                            <div>
                                                <app-policy-compliance-status
                                                    [category]="getPolicyCompliance(
                                                        effectivePolicy?.policy?.fdeSettings?.enableRememberMe,
                                                        fdeSettings?.enable_remember_me
                                                    )">
                                                </app-policy-compliance-status>
                                            </div>
                                        </div>
                                    </mat-card-content>
                                </mat-card>
                            }
                        }
                        @if (haveDataDefenseSubscription$ &&  !(isAgentInstalled(device))) {
                            <!-- 3 -->
                            <mat-card class="policy-section" appearance="raised">
                                <mat-card-header>
                                    <mat-card-title>
                                        <span class="policy-compliance-header">
                                            <span class="mdi mdi-check-decagram-outline card-title-icon"></span>{{'endpoints.col.policy-compliance' | translate}}
                                        </span>
                                    </mat-card-title>
                                    <app-d3e-device-compliance [compliant]="device?.policy_compliance?.protectedDirs === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.lockedDirs === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.protectedExts === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.lockedExts === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.encryptedProtectedDirs === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.encryptedLockedDirs === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.deceptionFiles === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.syncInterval === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.syncIntervalMetered === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.knownGood === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.preAuthFileAccessCount === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.preAuthFileAccessTimeout === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.forcePreAuthValues === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.ransomwareSensitivity === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.ransomwareFeatureMask === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.ransomExts === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.sensorConfigs === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.volumeConfigs === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.hklm_software_policies_microsoft_fve === PolicyCompliance.COMPLIANT">
                                    </app-d3e-device-compliance>
                                </mat-card-header>

                                <mat-card-content>
                                    <div class="policy-compliance-table-wrapper">
                                        <table class="policy-compliance" aria-label="BitLocker compliance information">
                                            <tr>
                                                <th scope="col" class="category">{{'endpoint.settings.category' | translate}}</th>
                                                <th scope="col">{{'D3ED_STATUS' | translate}}</th>
                                            </tr>

                                            <tr>
                                                <td class="category">{{'endpoint.settings.protected-dirs' | translate}}</td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.protectedDirs"></app-policy-compliance-status>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="category">{{'endpoint.settings.locked-dirs' | translate}}</td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.lockedDirs"></app-policy-compliance-status>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="category">{{'endpoint.settings.protected-exts' | translate}}</td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.protectedExts"></app-policy-compliance-status>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="category">{{'endpoints.settings.locked-extensions' | translate}}</td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.lockedExts"></app-policy-compliance-status>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="category">{{'endpoints.settings.encrypted-protected-dirs' | translate}}</td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.encryptedProtectedDirs"></app-policy-compliance-status>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="category">{{'endpoints.settings.encrypted-locked-dirs' | translate}}</td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.encryptedLockedDirs"></app-policy-compliance-status>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="category">{{'D3ED_DECEP_FIlES' | translate}}</td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.deceptionFiles"></app-policy-compliance-status>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="category">{{'SYNC_INTERVAL' | translate}}</td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.syncInterval"></app-policy-compliance-status>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="category">{{'SYNC_INTERVAL_METERED' | translate}}</td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.syncIntervalMetered"></app-policy-compliance-status>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="category">{{'endpoints.settings.known-good-apps' | translate}}</td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.knownGood"></app-policy-compliance-status>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="category">{{'PRE_AUTH_FILE_ACCESS_FREQ_COUNT' | translate}}</td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.preAuthFileAccessCount"></app-policy-compliance-status>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="category">{{'PRE_AUTH_FILE_ACCESS_COUNT' | translate}}</td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.preAuthFileAccessTimeout"></app-policy-compliance-status>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="category">{{'PRE_AUTH_FILE_ACCESS_FREQ_TYPE' | translate}}</td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.forcePreAuthValues"></app-policy-compliance-status>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="category">{{'policy.ransomware.sensitivity' | translate}}</td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.ransomwareSensitivity"></app-policy-compliance-status>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="category">{{'policy.ransomware.feature-mask.label' | translate}}</td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.ransomwareFeatureMask"></app-policy-compliance-status>
                                                </td>

                                            <tr>
                                                <td class="category">{{'endpoints.settings.ransomware-extensions' | translate}}</td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.ransomExts"></app-policy-compliance-status>
                                                </td>
                                            </tr>

                                            <tr>
                                                <th scope="row" class="category" colspan="2">{{'SETTINGS' | translate}}</th>
                                            </tr>

                                            <tr>
                                                <td class="category">
                                                    {{'endpoints.settings.configurable-sensors' | translate}}
                                                    <span matTooltip="{{'endpoints.settings.sensors-label' | translate}}"
                                                        matTooltipPosition="right">
                                                        <a [routerLink]="['/admin-settings', 'sensors']">
                                                            <span class="mdi mdi-open-in-new"></span>
                                                        </a>
                                                    </span>
                                                </td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.sensorConfigs"></app-policy-compliance-status>
                                                </td>
                                            </tr>

                                            <tr>
                                                <th scope="row" class="category" colspan="2">{{'bitlocker-compliance.title' | translate}}</th>
                                            </tr>

                                            <tr>
                                                <td class="category">
                                                    {{'endpoint.settings.bitlocker-label' | translate}}
                                                    <span matTooltip="{{'endpoints.settings.bitlocker-compliance' | translate}}"
                                                        matTooltipPosition="right">
                                                        <a [routerLink]="['/device', device.uuid]" [queryParams]="{'tab': 'bitlocker'}">
                                                            <span class="mdi mdi-open-in-new"></span>
                                                        </a>
                                                    </span>
                                                </td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.volumeConfigs"></app-policy-compliance-status>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="category">
                                                    {{'endpoint.settings.registry-keys' | translate}}
                                                    <span matTooltip="{{'endpoints.settings.bitlocker-compliance' | translate}}"
                                                        matTooltipPosition="right">
                                                        <a [routerLink]="['/device', device.uuid]" [queryParams]="{'tab': 'bitlocker'}">
                                                            <span class="mdi mdi-open-in-new"></span>
                                                        </a>
                                                    </span>
                                                </td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.hklm_software_policies_microsoft_fve"></app-policy-compliance-status>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </mat-card-content>
                            </mat-card>
                        }
                        </div>
                    }
                    @else {
                        <div class="card-wrapper">
                            <mat-card appearance="raised">
                                <mat-card-header>
                                    <mat-card-title>
                                        <span class="mdi mdi-application-settings card-title-icon"></span>Endpoint Settings
                                    </mat-card-title>
                                </mat-card-header>
                                <mat-card-content>
                                    <div class="content-wrapper">
                                        <div class="settings-wrapper">
                                            <span class="setting-label">
                                                {{ 'ALC_POLICY' | translate }}
                                                <span matTooltip="{{'ALC_POLICY_TIP' | translate}}" matTooltipPosition="right">
                                                    <span class="mdi mdi-information-outline"></span>
                                                </span>
                                            </span>
                                            <span class="setting-value">
                                                @if (user$ | async; as user) {
                                                    @if (user.role === UserRole.ADMIN) {
                                                        <a [routerLink]="['/policy', effectivePolicy?.policy_id]"
                                                        [queryParams]="{selectedOrgId: effectivePolicy?.effective_group_id}">
                                                            {{ effectivePolicy?.policy_name }}
                                                        </a>
                                                    } @else {
                                                        {{ effectivePolicy?.policy_name }}
                                                    }
                                                }
                                            </span>
                                        </div>
                                        <div class="settings-wrapper">
                                            <span class="setting-label">
                                                {{ 'ALC_POLICY_UPDATE' | translate }}
                                                <span matTooltip="{{'ALC_POLICY_TIPB' | translate}}" matTooltipPosition="right">
                                                    <span class="mdi mdi-information-outline"></span>
                                                </span>
                                            </span>
                                            <span class="setting-value">{{ displayDate(effectivePolicy?.last_policy_dttm) }}</span>
                                        </div>
                                        <div class="settings-wrapper">
                                            <span class="setting-label">
                                                {{ fConfig }}
                                                <span matTooltip="{{'ALC_CONFIG_TIP' | translate}}" matTooltipPosition="right">
                                                    <span class="mdi mdi-information-outline"></span>
                                                </span>
                                            </span>
                                            <span class="setting-value">{{ displayDate(device.last_config_dttm) }}</span>
                                        </div>
                                        <div class="settings-wrapper">
                                            <span class="setting-label">
                                                {{ 'ALC_SYNC' | translate }}
                                                <span matTooltip="{{'ALC_SYNC_TIP' | translate}}" matTooltipPosition="right">
                                                    <span class="mdi mdi-information-outline"></span>
                                                </span>
                                            </span>
                                            <span class="setting-value">{{ device.config ? getInterval(device.config.syncInterval) : 'No Configuration' }}</span>
                                        </div>
                                        <div *ngIf="device.config?.syncIntervalMetered" class="settings-wrapper">
                                            <span class="setting-label">
                                                {{ 'ALC_SYNC_METER' | translate }}
                                                <span matTooltip="{{'ALC_SYNC_TIPB' | translate}}" matTooltipPosition="right">
                                                    <span class="mdi mdi-information-outline"></span>
                                                </span>
                                            </span>
                                            <span class="setting-value">{{ device.config ? getInterval(device.config.syncIntervalMetered) : 'No Configuration' }}</span>
                                        </div>
                                        <div class="settings-wrapper">
                                            <span class="setting-label">
                                                {{'PRE_AUTH_FILE_ACCESS_FREQ_COUNT' | translate}}
                                                <span matTooltip="{{'PRE_AUTH_FILE_ACCESS_COUNT_TOOLTIP' | translate}}">
                                                    <span class="mdi mdi-information-outline"></span>
                                                </span>
                                            </span>
                                            <span class="setting-value" *ngIf="device?.config?.preAuthFileAccessCount !== null; else noFiles">
                                            {{ device.config.preAuthFileAccessCount | i18nPlural:filePluralMapping }}
                                            </span>
                                            <ng-template #noFiles><span class="setting-value">N/A</span></ng-template>
                                        </div>
                                        <div class="settings-wrapper">
                                            <span class="setting-label">
                                                {{'PRE_AUTH_FILE_ACCESS_COUNT' | translate}}
                                                <span matTooltip="{{'PRE_AUTH_FILE_ACCESS_COUNT_TOOLTIP' | translate}}">
                                                    <span class="mdi mdi-information-outline"></span>
                                                </span>
                                            </span>
                                            <span class="setting-value" *ngIf="device?.config?.preAuthFileAccessTimeout !== null && device?.config?.preAuthFileAccessTimeout > 0; else unlimited">
                                            {{ getIntervalMinutes(device.config.preAuthFileAccessTimeout) }}
                                            </span>
                                            <ng-template #unlimited><span class="setting-value">Unlimited</span></ng-template>
                                        </div>
                                        <div class="settings-wrapper">
                                            <span class="setting-label">
                                                {{'PRE_AUTH_FILE_ACCESS_FREQ_TYPE' | translate}}
                                                <span matTooltip="{{'FORCE_PRE_AUTH_VALUES_TOOLTIP' | translate}}">
                                                    <span class="mdi mdi-information-outline"></span>
                                                </span>
                                            </span>
                                            <span class="setting-value">
                                            {{ getReAuthFrequencyLabel(device.config?.forcePreAuthValues) }}
                                            </span>
                                        </div>
                                        <div class="settings-wrapper">
                                            <span class="setting-label">
                                                {{'policy.ransomware.sensitivity-min' | translate}}
                                                <span matTooltip="{{ 'policy.ransomware.sensitivity-tooltip' | translate}}">
                                                    <span class="mdi mdi-information-outline"></span>
                                                </span>
                                            </span>
                                            <span class="setting-value">
                                            {{ device.config?.ransomwareSensitivityMin }}
                                            </span>
                                        </div>
                                        <div class="settings-wrapper">
                                            <span class="setting-label">
                                                {{'policy.ransomware.sensitivity-max' | translate}}
                                                <span matTooltip="{{ 'policy.ransomware.sensitivity-tooltip' | translate}}">
                                                    <span class="mdi mdi-information-outline"></span>
                                                </span>
                                            </span>
                                            <span class="setting-value">
                                            {{ device.config?.ransomwareSensitivityMax }}
                                            </span>
                                        </div>

                                        <div class="settings-wrapper">
                                            <span class="setting-label">
                                                {{'policy.ransomware.feature-mask.label' | translate}}
                                                <span matTooltip="{{ 'policy.ransomware.feature-mask.tooltip' | translate}}">
                                                    <span class="mdi mdi-information-outline"></span>
                                                </span>
                                            </span>
                                            <span class="setting-value">
                                            {{ getFeatureMask(device.config?.ransomwareFeatureMask) }}
                                            </span>
                                        </div>

                                    </div>
                                </mat-card-content>
                            </mat-card>
                            <mat-card appearance="raised">
                                <mat-card-header>
                                    <mat-card-title>
                                        <span class="policy-compliance-header">
                                            <span>
                                                <span class="mdi mdi-check-decagram-outline card-title-icon"></span>{{'endpoints.col.policy-compliance' | translate}}
                                            </span>
                                        </span>
                                    </mat-card-title>
                                    <app-d3e-device-compliance [compliant]="device?.policy_compliance?.protectedDirs === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.lockedDirs === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.protectedExts === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.lockedExts === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.encryptedProtectedDirs === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.encryptedLockedDirs === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.deceptionFiles === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.syncInterval === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.syncIntervalMetered === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.knownGood === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.preAuthFileAccessCount === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.preAuthFileAccessTimeout === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.forcePreAuthValues === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.ransomwareSensitivity === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.ransomwareFeatureMask === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.ransomExts === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.sensorConfigs === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.volumeConfigs === PolicyCompliance.COMPLIANT &&
                                                                            device?.policy_compliance?.hklm_software_policies_microsoft_fve === PolicyCompliance.COMPLIANT">
                                    </app-d3e-device-compliance>
                                </mat-card-header>
                                <mat-card-content class="policy-compliance-content">
                                    <div class="policy-compliance-table-wrapper">
                                        <table class="policy-compliance" aria-label="BitLocker compliance information">
                                            <tr>
                                                <th scope="col" class="category">{{'endpoint.settings.category' | translate}}</th>
                                                <th scope="col">{{'D3ED_STATUS' | translate}}</th>
                                            </tr>

                                            <tr>
                                                <td class="category">{{'endpoint.settings.protected-dirs' | translate}}</td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.protectedDirs"></app-policy-compliance-status>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="category">{{'endpoint.settings.locked-dirs' | translate}}</td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.lockedDirs"></app-policy-compliance-status>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="category">{{'endpoint.settings.protected-exts' | translate}}</td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.protectedExts"></app-policy-compliance-status>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="category">{{'endpoints.settings.locked-extensions' | translate}}</td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.lockedExts"></app-policy-compliance-status>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="category">{{'endpoints.settings.encrypted-protected-dirs' | translate}}</td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.encryptedProtectedDirs"></app-policy-compliance-status>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="category">{{'endpoints.settings.encrypted-locked-dirs' | translate}}</td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.encryptedLockedDirs"></app-policy-compliance-status>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="category">{{'D3ED_DECEP_FIlES' | translate}}</td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.deceptionFiles"></app-policy-compliance-status>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="category">{{'SYNC_INTERVAL' | translate}}</td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.syncInterval"></app-policy-compliance-status>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="category">{{'SYNC_INTERVAL_METERED' | translate}}</td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.syncIntervalMetered"></app-policy-compliance-status>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="category">{{'endpoints.settings.known-good-apps' | translate}}</td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.knownGood"></app-policy-compliance-status>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="category">{{'PRE_AUTH_FILE_ACCESS_FREQ_COUNT' | translate}}</td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.preAuthFileAccessCount"></app-policy-compliance-status>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="category">{{'PRE_AUTH_FILE_ACCESS_COUNT' | translate}}</td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.preAuthFileAccessTimeout"></app-policy-compliance-status>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="category">{{'PRE_AUTH_FILE_ACCESS_FREQ_TYPE' | translate}}</td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.forcePreAuthValues"></app-policy-compliance-status>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="category">{{'policy.ransomware.sensitivity' | translate}}</td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.ransomwareSensitivity"></app-policy-compliance-status>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="category">{{'policy.ransomware.feature-mask.label' | translate}}</td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.ransomwareFeatureMask"></app-policy-compliance-status>
                                                </td>

                                            <tr>
                                                <td class="category">{{'endpoints.settings.ransomware-extensions' | translate}}</td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.ransomExts"></app-policy-compliance-status>
                                                </td>
                                            </tr>

                                            <tr>
                                                <th scope="row" class="category" colspan="2">{{'SETTINGS' | translate}}</th>
                                            </tr>

                                            <tr>
                                                <td class="category">
                                                    {{'endpoints.settings.configurable-sensors' | translate}}
                                                    <span matTooltip="{{'endpoints.settings.sensors-label' | translate}}"
                                                        matTooltipPosition="right">
                                                        <a [routerLink]="['/admin-settings', 'sensors']">
                                                            <span class="mdi mdi-open-in-new"></span>
                                                        </a>
                                                    </span>
                                                </td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.sensorConfigs"></app-policy-compliance-status>
                                                </td>
                                            </tr>

                                            <tr>
                                                <th scope="row" class="category" colspan="2">{{'bitlocker-compliance.title' | translate}}</th>
                                            </tr>

                                            <tr>
                                                <td class="category">
                                                    {{'endpoint.settings.bitlocker-label' | translate}}
                                                    <span matTooltip="{{'endpoints.settings.bitlocker-compliance' | translate}}"
                                                        matTooltipPosition="right">
                                                        <a [routerLink]="['/device', device.uuid]" [queryParams]="{'tab': 'bitlocker'}">
                                                            <span class="mdi mdi-open-in-new"></span>
                                                        </a>
                                                    </span>
                                                </td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.volumeConfigs"></app-policy-compliance-status>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="category">
                                                    {{'endpoint.settings.registry-keys' | translate}}
                                                    <span matTooltip="{{'endpoints.settings.bitlocker-compliance' | translate}}"
                                                        matTooltipPosition="right">
                                                        <a [routerLink]="['/device', device.uuid]" [queryParams]="{'tab': 'bitlocker'}">
                                                            <span class="mdi mdi-open-in-new"></span>
                                                        </a>
                                                    </span>
                                                </td>
                                                <td>
                                                    <app-policy-compliance-status [category]="device?.policy_compliance?.hklm_software_policies_microsoft_fve"></app-policy-compliance-status>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </mat-card-content>
                            </mat-card>
                        </div>
                    }
                </mat-tab>
            }
        </mat-tab-group>
    </mat-card-content>
</mat-card>
